export default {
    app: {
        name:     'Uprava',
        product:  'Imprion PMS',
        subtitle: 'konzola verige',
    },

    general: {
        cancel:             'Prekliči',
        close:              'Zapri',
        confirm:            'Potrditev',
        delete:             'Izbriši',
        edit:               'Uredi',
        hint:               'Pojasnilo',
        loading:            'Nalaganje …',
        remove:             'Odstrani',
        no:                 'Ne',
        no_data:            'Ni podatkov',
        no_match:           'Ni zadetkov',
        not_ready:          'Ta pogled še ni na voljo',
        not_ready_hint:     'Storitev te poti še ne nosi. Ko izide, se zaslon izriše sam.',
        open_in_reception:  'Odpri recepcijo',
        pick_date:          'Izberi datum',
        save:               'Shrani',
        select_confirm:     'Potrdi',
        selected_count:     'izbranih: {count}',
        try_again:          'Poskusi znova',
        yes:                'Da',
    },

    errors: {
        already_exists:   'Zapis že obstaja',
        confirm_moved_on: 'Dejanje je preklicano — medtem ste odprli drug zapis',
        forbidden:        'Nimate pravice za to dejanje',
        generic_error:    'Prišlo je do napake',
        invalid_data:     'Neveljavni podatki',
        load_failed:      'Podatkov ni bilo mogoče prebrati',
        not_found:        'Ni najdeno',
        on_add:           'Napaka pri dodajanju',
        on_delete:        'Napaka pri brisanju',
        on_edit:          'Napaka pri shranjevanju',
        on_load:          'Napaka pri branju podatkov',
        open_failed:      'Recepcije ni bilo mogoče odpreti',
        popup_blocked:    'Brskalnik je zavrnil nov zavihek. Dovolite pojavna okna za to stran.',
        session_expired:  'Seja je potekla, prijavite se znova',
        unauthorized:     'Nimate pravice za to dejanje',
    },

    validation: {
        bic:      'BIC ima 8 ali 11 znakov',
        country:  'Oznaka države ima dve črki (SI)',
        currency:      'Oznaka valute ima tri črke (EUR)',
        rate_positive: 'Tečaj mora biti večji od nič',
        sections_required: 'Dodajte vsaj en razdelek',
        required: 'To polje je obvezno',
        too_long: 'Vnos je predolg',
        weekdays_required: 'Izberite vsaj en dan',
    },

    nav: {
        campaigns:     'Kampanje',
        accounting:    'Knjigovodstvo',
        alerts:        'Opozorila',
        budgets:       'Proračun',
        channels:      'Kanali',
        contracts:     'Pogodbe',
        entities:     'Družbe',
        fx:            'Tečaji',
        group_section: 'Skupina',
        intercompany:  'Medpodjetniško',
        language:     'Jezik',
        language_en:  'Angleščina',
        language_sl:  'Slovenščina',
        marketing_roi: 'ROI',
        materials:     'Nabava',
        loans:         'Posoje',
        master_groups: 'Skupine',
        logout:       'Odjava',
        menu:         'Meni',
        month_close:   'Zaključek meseca',
        milo:          'Milo',
        operations:    'Zapisi',
        overview:     'Pregled',
        payroll:       'Plače',
        people:        'Ljudje',
        pickup:        'Pickup',
        pnl:            'Izkaz',
        rate_templates: 'Ceniki',
        staff:          'Kadri',
        reports:       'Poročila',
        reservations:  'Rezervacije',
        structure:    'Struktura',
        theme:        'Tema',
        theme_dark:   'Temna',
        theme_light:  'Svetla',
        theme_system: 'Sistemska',
    },

    login: {
        demo_signing_in: 'Prijavljam …',
        demo_failed: 'Te vloge na tem strežniku ni.',
        failed:   'Napačno uporabniško ime ali geslo',
        password: 'Geslo',
        submit:   'Prijava',
        title:    'Prijava v konzolo verige',
        username: 'Uporabniško ime',
    },

    scope: {
        covers:          'Obseg — objektov: {count}',
        kind_entity:     'Ena družba',
        kind_group:      'Cela skupina',
        kind_properties: 'Izbrani objekti',
        kind_unit:       'Regija ali znamka',
        label:           'Obseg',
        pick_entity:     'Izberite družbo',
        pick_properties: 'Izberite objekte',
        pick_unit:       'Izberite enoto',
        picked:          'Izbranih objektov: {count}',
    },

    // Kadar račun ne drži nobene pravice skupine — en stavek namesto prazne plošče z
    // rdečim okvirjem (docs/PRAVICE_IN_OBSEG.md §5).
    no_access: {
        description: 'Vaš račun ne drži nobene pravice uprave verige, zato v tej konzoli ni zaslona, ki bi ga lahko odprli. Pravico dodeli skrbnik v recepcijskem portalu, pod Nastavitve → Vloge.',
        sign_out:    'Odjava',
        title:       'Brez dostopa do uprave verige',
    },

    overview: {
        no_houses: 'V tem obsegu ni objektov',
        title:     'Pregled',
    },

    /**
     * The one line every consolidated board carries under its tiles.
     * `components/ConsolidationNote.vue`.
     */
    consolidation: {
        as_of:  'zajeto ob {time}',
        houses: 'Vključenih hiš {included} od {total}',
        rate:   'tečaj za {month}',
    },

    age: {
        just_now:    'pravkar',
        days_one:    '{count} dan',
        days_two:    '{count} dneva',
        days_few:    '{count} dnevi',
        days_other:  '{count} dni',
        hours_one:   '{count} ura',
        hours_two:   '{count} uri',
        hours_few:   '{count} ure',
        hours_other: '{count} ur',
    },

    flash: {
        change_vs_last_year:  '{change} proti lani (MTD)',
        column_adr:           'ADR',
        column_arrivals:      'Prihodi',
        column_company:       'Družba',
        column_house:         'Hiša',
        column_in_house:      'V hiši',
        column_mtd:           'MTD proti lani',
        column_occupancy:     'Zasedenost',
        column_revpar:        'RevPAR',
        column_room_revenue:  'Prihodek sob',
        column_rooms:         'Sobe',
        column_status:        'Stanje',
        excluded_hint:        'Te hiše storitev ni vštela v vsoto skupine.',
        excluded_title:       'Izvzete hiše',
        in_house_hint:        '{arrivals} prihodov · {departures} odhodov · {noShows} neprihodov',
        legend_closed:        'zaključeno',
        legend_currency:      '{currency} je valuta poročanja · tuje valute po mesečnem tečaju ({month})',
        legend_missing:       'manjka v vsoti',
        live_failed:          'trenutnega stanja ni bilo mogoče prebrati',
        next_day:             'Naslednji dan',
        no_company:           'brez družbe',
        no_last_year:         'brez primerjave z lani',
        no_rate_short:        'brez tečaja',
        no_rows:              'Za ta dan ni podatkov',
        pill_missing:         'hiš brez nočnega zaključka: {count}',
        pill_no_company:      'hiš brez družbe: {count}',
        pill_rate:            '{currency} {rate} · {month}',
        points_vs_last_year:  '{points} t. proti lani (MTD)',
        previous_day:         'Prejšnji dan',
        status_closed:        'zaključeno',
        status_closed_at:     'zaključeno {time}',
        status_missing:       'nočni zaključek ni tekel',
        status_no_rate:       'brez tečaja',
        subtitle:             'dnevni flash čez hiše',
        table_title:          'Po hišah',
        tile_adr:             'ADR',
        tile_in_house:        'Danes v hiši',
        tile_mtd_revenue:     'Prihodek sob MTD',
        tile_occupancy:       'Zasedenost',
        tile_revpar:          'RevPAR',
        tile_rooms_sold:      'Prodane sobe',
        tile_rooms_sold_hint: 'zaključenih hiš: {closed} od {total}',
        today:                'danes',
        total_missing:        'manjka hiš: {count}',
        total_row:            'Skupina ({counted} od {total} hiš)',
    },

    payroll: {
        blocked:              'Mesec ni zaključen: {houses} (hiš: {count}). Zaključite mesec v hiši ali vklopite Osnutek.',
        blocked_unreadable:   'Ene od hiš ni bilo mogoče prebrati. Poskusite znova ali vklopite Osnutek.',
        column_absence:       'Odsotnosti',
        column_balance:       'Razlika',
        column_closed_at:     'Zaključeno',
        column_department:    'Oddelek',
        column_employee_no:   'Št. zaposlenega',
        column_expected:      'Pričakovano',
        column_hash:          'Hash',
        column_house:         'Hiša',
        column_name:          'Ime',
        column_payroll_code:  'Plačna šifra',
        column_rows:          'Vrstic',
        column_status:        'Stanje',
        column_version:       'Verzija',
        column_worked:        'Opravljeno',
        company:              'Družba',
        company_chip:         'Šifra podjetja: {code}',
        download:             'Prenesi CSV',
        download_hint:        'Prenese datoteko za računovodstvo (CSV, UTF-8)',
        draft:                'Osnutek',
        draft_badge:          'Osnutek',
        draft_hint:           'dovoli prenos mesecev, ki še niso zaključeni',
        excluded_title:       'Izpuščene hiše',
        final:                'Zaključeno',
        home_property:        'matična hiša: {house}',
        house_unreadable:     'Meseca hiše {house} ni bilo mogoče prebrati',
        houses_hint:          'Ena vrstica je ena hiša. Odprt ali ponovno odprt mesec ustavi zaključeno datoteko.',
        houses_title:         'Hiše v datoteki',
        legend_balance:       'Razlika je opravljeno + odsotnosti − pričakovano. Ni nadur.',
        legend_blocking:      'Obarvana vrstica: mesec te hiše še ni zaključen.',
        legend_hash:          'Hash je prstni odtis zaključenega meseca hiše.',
        legend_mismatch:      'Obarvana vrstica: matična hiša osebe je v lasti druge družbe.',
        mismatch_badge:       'Druga družba',
        mismatch_tooltip:     'matično hišo te osebe ima v lasti druga družba',
        mixed_settings:       'Različne nastavitve',
        mixed_settings_hint:  'Hiše te datoteke ne pišejo količin enako. Datoteka uporabi nastavitve prve hiše.',
        month:                'Mesec',
        no_companies:         'V registru ni nobene aktivne družbe',
        no_houses:            'V tem mesecu ni nobene hiše te družbe',
        no_rows:              'V tem mesecu ni nobene osebe te družbe',
        rows_hint:            'Ena vrstica je ena oseba v eni hiši. Kdor je delal v dveh hišah, ima dve vrstici.',
        rows_title:           'Vrstice za obračun',
        status_closed:        'Zaključen',
        status_missing:       'Ni evidence',
        status_open:          'Odprt',
        status_reopened:      'Ponovno odprt',
        subtitle:             'obračun po družbi, čez vse hiše skupine',
        tile_balance:         'Razlika',
        tile_balance_hint:    'opravljeno + odsotnosti − pričakovano',
        tile_houses:          'Hiše',
        tile_houses_hint:     'nezaključenih: {count}',
        tile_people:          'Ljudje',
        tile_people_hint:     'vrstic: {count}',
        tile_worked:          'Opravljeno',
        tile_worked_hint:     'pričakovano: {value}',
        title:                'Plače',
        total_row:            'Skupaj (oseb: {count})',
    },

    people: {
        account_inactive:        'račun ni aktiven',
        basis_agency_worker:     'Napoteni delavec',
        basis_copyright_contract: 'Avtorska pogodba',
        basis_employment_contract: 'Pogodba o zaposlitvi',
        basis_other:             'Drugo',
        basis_pensioner_temporary: 'Začasno delo upokojenca',
        basis_self_employed:     'Samozaposleni (s. p.)',
        basis_service_contract:  'Podjemna pogodba',
        basis_short_term_family_work: 'Kratkotrajno delo',
        basis_student_work:      'Študentsko delo',
        basis_traineeship:       'Pripravništvo',
        capped:                  'Prikazan je prvi del registra',
        capped_hint:             'Odgovor je omejen na 2000 vrstic. Zožite obseg, dan ali iskanje, da vidite ostale.',
        column_basis:            'Podlaga',
        column_company:          'Družba',
        column_department:       'Oddelek',
        column_home:             'Matična hiša',
        column_name:             'Ime',
        column_period:           'Velja',
        column_position:         'Delovno mesto',
        column_time:             'Čas',
        column_works_in:         'Dela v',
        company_all:             'Vse družbe',
        company_chip:            '{name}: {count}',
        company_filter:          'Družba',
        fix_company:             'Popravi družbo',
        fix_company_confirm:     'Pogodbo osebe {person} prenesti na družbo {company}? To odloča, kdo oddaja njen obračun.',
        fix_company_saved:       'Družba pogodbe je zdaj {company}',
        house_unreadable:        'Šifranta hiše {house} ni bilo mogoče prebrati',
        legend_mismatch:         'Obarvana vrstica: pogodba je pri drugi družbi kot hiša.',
        legend_row:              'Klik na vrstico odpre obdobja te osebe.',
        mismatch_badge:          'Druga družba',
        mismatch_tooltip:        'pogodba pri drugi družbi kot hiša',
        no_company:              'Brez družbe',
        no_people:               'Na ta dan v tem obsegu ni nikogar',
        no_periods:              'Ta oseba nima obdobij dela',
        on_day:                  'Na dan',
        open_period:             'do preklica',
        open_personnel:          'Odpri kadrovsko',
        open_personnel_hint:     'Odpre kadrovsko kartico v recepciji matične hiše',
        outside_scope:           'zunaj obsega',
        person_title:            'Oseba',
        search_placeholder:      'Ime, uporabniško ime ali matična številka',
        subtitle:                'kdo dela v skupini in pri kateri družbi',
        table_hint:              'Ena vrstica je ena oseba. Kdor dela v dveh hišah, je ena pogodba z dvema hišama.',
        table_title:             'Register ljudi',
        tile_mismatches:         'Neskladja',
        tile_mismatches_hint:    'pogodba pri drugi družbi kot hiša',
        tile_people:             'Ljudje',
        tile_people_hint:        'matičnih hiš: {count}',
        tile_without_company:    'Brez družbe',
        tile_without_company_hint: 'pogodba ni dodeljena nobeni družbi',
        time_full_time:          'Polni čas',
        time_part_time:          'Krajši čas',
        title:                   'Ljudje',
    },

    loans: {
        add:                        'Nova posoja',
        add_hint:                   'Posodi osebo drugi hiši skupine za določeno obdobje.',
        add_title:                  'Nova posoja',
        added:                      'Posoja je zapisana',
        badge_intercompany:         'Med družbama',
        badge_same_company:         'Ista družba',
        cancel_confirm:             'Preklicati posojo osebe {person} v hišo {house}? Posoja se še ni začela, zato ne bo izvedena.',
        cancel_failed:              'Posoje ni bilo mogoče preklicati',
        cancel_hint:                'Prekliče posojo, ki se še ni začela',
        cancel_reason_default:      'Preklic iz uprave.',
        cancelled_toast:            'Posoja osebe {person} je preklicana',
        capped:                     'Prikazan je prvi del registra',
        capped_hint:                'Odgovor je omejen na 2000 vrstic. Zožite obseg ali mesec, da vidite ostale.',
        column_cost_centre:         'Stroškovno mesto',
        column_department:          'Oddelek',
        column_from_house:          'Iz hiše',
        column_hours:               'Ure',
        column_loans:               'Posoj',
        column_people:              'Ljudi',
        column_period:              'Obdobje',
        column_person:              'Oseba',
        column_relation:            'Razmerje',
        column_status:              'Stanje',
        column_to_house:            'V hišo',
        departments_failed:         'Oddelkov te hiše ni bilo mogoče prebrati',
        edit_hint:                  'Popravi obdobje, oddelek ali stroškovno mesto. Osebe in hiše ni mogoče zamenjati.',
        edit_title:                 'Popravek posoje',
        end:                        'Končaj',
        end_hint:                   'Konča posojo, ki teče — zadnji dan se prestavi na danes',
        field_cost_centre:          'Stroškovno mesto',
        field_cost_centre_hint:     'Prazno pomeni stroškovno mesto oddelka, ki sprejema. Vpis je izjema za to posojo in se zamrzne.',
        field_cost_centre_placeholder: 'kot pri oddelku',
        field_department:           'Oddelek v hiši, ki sprejema',
        field_department_hint:      'Oddelek šifranta hiše, ki sprejema. Na njenem urniku oseba stoji pod tem oddelkom.',
        field_department_placeholder: 'Izberi oddelek',
        field_from:                 'Od',
        field_person:               'Oseba',
        field_person_hint:          'Išče po imenu, uporabniškem imenu in matični številki. Hiša, ki posodi, je matična hiša te osebe.',
        field_person_placeholder:   'Poišči osebo',
        field_reason:               'Razlog',
        field_reason_hint:          'Zakaj je oseba posojena. Ni obvezno, je pa edino, kar čez pol leta pojasni to vrstico.',
        field_to:                   'Do',
        field_to_hint:              'Zadnji dan posoje, vključno. Posoja brez konca ni posoja.',
        field_to_property:          'V hišo',
        field_to_property_hint:     'Hiša, ki osebo sprejme. Ure se štejejo v evidenco te hiše.',
        field_to_property_placeholder: 'Izberi hišo',
        house_unreadable:           'Podatkov hiše {house} ni bilo mogoče prebrati',
        intercompany_tooltip:       'hiši sta pri različnih družbah',
        legend_hours:               'Ure so opravljene v hiši, ki sprejema, znotraj obdobja posoje. Brez modula evidence so 0.',
        legend_intercompany:        'Obarvana vrstica: hiši sta pri različnih družbah.',
        legend_summary:             'Ena vrstica je ena smer med dvema hišama. Znesekov ni: medpodjetniški račun je svoj paket.',
        month:                      'Mesec',
        no_company:                 'Brez družbe',
        no_loans:                   'V tem mesecu v tem obsegu ni nobene posoje',
        no_pairs:                   'V tem mesecu ni nobene posoje med hišami',
        open_rota:                  'Odpri urnik',
        open_rota_hint:             'Odpre urnik v recepciji hiše, ki sprejema',
        saved:                      'Posoja je popravljena',
        status:                     'Stanje',
        status_active:              'Teče',
        status_all:                 'Vsa stanja',
        status_cancelled:           'Preklicana',
        status_ended:               'Končana',
        status_planned:             'Načrtovana',
        subtitle:                   'kdo od naših ljudi dela v drugi hiši skupine',
        summary_hint:               'Ena vrstica je ena smer: hiša, ki posodi, in hiša, ki sprejme. Podlaga za medpodjetniški obračun.',
        summary_title:              'Povzetek po parih',
        table_hint:                 'Ena vrstica je ena posoja. Ure so iz evidence hiše, ki sprejema, in se nikamor ne prenašajo.',
        table_title:                'Posoje v mesecu',
        tile_hours:                 'Ure v tujih hišah',
        tile_hours_hint:            'znotraj obdobij posoj',
        tile_intercompany:          'Med družbami',
        tile_intercompany_hint:     'posoje čez mejo davčnega zavezanca',
        tile_loans:                 'Posoje',
        tile_people:                'Ljudje',
        tile_people_hint:           'ena oseba je lahko posojena večkrat',
        title:                      'Posoje',
        total_row:                  'Skupaj',
    },

    pickup: {
        column_house:   'Hiša',
        horizon:        'Obdobje',
        horizon_months: 'naslednjih {count} mesecev',
        legend_nights:  'zgornja številka so prodane nočitve (OTB)',
        legend_revenue: 'spodnja številka je prihodek v {currency}',
        no_data:        'Za to obdobje ni ničesar na knjigah',
        subtitle:       'kaj je že na knjigah',
        table_hint:     'Stanje na knjigah po mesecih. Brez napovedi in brez proračuna.',
        table_title:    'Po hišah in mesecih',
        title:          'Pickup',
        total_row:      'Skupina (hiš: {count})',
    },

    budget: {
        column_house:              'Hiša',
        copied:                    'Preneseno iz {from} v {to}: celic {count}',
        copy:                      'Kopiraj v naslednje leto',
        copy_all_metrics:          'vsi kazalniki',
        copy_factor:               'Faktor (%)',
        copy_factor_hint:          '100 pomeni „isto še enkrat“, 105 pet odstotkov več.',
        copy_from_year:            'Iz leta',
        copy_hint:                 'Vsak mesec vsakega kazalnika izbranih hiš se prepiše v ciljno leto. Drugi pritisk prepiše prvega in ne pomnoži.',
        copy_metrics:              'Kazalniki',
        copy_metrics_hint:         'Prazno pomeni vse. Zasedenosti običajno ne skaliramo — hotel nima petih odstotkov več sob.',
        copy_title:                'Prenos proračuna v drugo leto',
        copy_to_year:              'V leto',
        excluded_hint:             'Teh mesecev storitev ni vštela v vsoto skupine.',
        excluded_months:           'meseci: {months}',
        excluded_title:            'Izvzeti meseci',
        legend_converted:          'druga vrstica je preračun v {currency} po mesečnem tečaju',
        legend_house_currency:     'vpisuje se v valuti hiše (koda je v glavi vrstice)',
        legend_no_group_occupancy: 'skupina nima načrtovane zasedenosti: povprečje hišnih razmerij ni številka',
        legend_no_rate:            'mesec brez tečaja — denar ni izrazljiv in ni v vsoti',
        legend_stack:              'zgoraj načrt, sredina dejansko, spodaj odstopanje',
        metric:                    'Kazalnik',
        metric_fnb_revenue:        'Hrana in pijača',
        metric_occupancy_bp:       'Zasedenost',
        metric_other_revenue:      'Drugi prihodki',
        metric_room_revenue:       'Prihodek sob',
        metric_rooms_sold:         'Prodane sobo-noči',
        metric_total_revenue:      'Skupni prihodek',
        no_actual:                 'ni dejanskega',
        no_data:                   'Za to leto ni ničesar',
        no_plan:                   'ni načrta',
        no_rate:                   'brez tečaja',
        save:                      'Shrani ({count})',
        saved:                     'Shranjenih celic: {count}',
        saving_hint:               'Med shranjevanjem je mreža zaklenjena, da se vpis ne izgubi.',
        subtitle:                  'kaj smo obljubili in kako nam gre',
        table_actual:              '{metric} — načrt proti dejanskemu',
        table_actual_hint:         'Po hišah in mesecih, v valuti poročanja. Vsota pokriva samo mesece z načrtom in dejanskim.',
        table_plan:                '{metric} — načrt',
        table_plan_hint:           'Načrt po hišah in mesecih. Vpisuje se v valuti hiše, bere v valuti poročanja.',
        title:                     'Proračun',
        total_row:                 'Skupina (hiš: {count})',
        view:                      'Pogled',
        view_actual:               'Načrt proti dejanskemu',
        view_plan:                 'Načrt',
        year:                      'Leto',
    },


    pnl: {
        chart_cost:                'Znani stroški',
        chart_hint:                'Skupina po mesecih. Marža je narisana samo tam, kjer sta oba stroška prebrana.',
        chart_margin:              'Marža',
        chart_no_margin:           'Marže še ni mogoče izračunati: strošek dela za te mesece ni prebran.',
        chart_revenue:             'Prihodek',
        chart_title:               'Gibanje (12 mesecev)',
        column_company:            'Družba',
        column_group:              'Skupina',
        column_house:              'Hiša',
        column_labour:             'Delo',
        column_margin:             'Marža',
        column_margin_share:       'Marža %',
        column_materials:          'Material',
        column_per_night:          'Na sobo-noč',
        column_plan:               'Načrt',
        column_revenue:            'Prihodek',
        column_status:             'Stanje',
        eliminations_hint:         'Marža, ki jo je skupina zaračunala sama sebi, ko je blago prečkalo mejo med družbama.',
        eliminations_in_rows:      'Odšteta je od stroška materiala v vrstici skupine in v vsoti.',
        eliminations_invoices:     'iz {count} izdanih računov',
        eliminations_no_rate:      'Računov brez tečaja meseca: {count}. Njihova marža ni odšteta.',
        eliminations_revenue_note: 'Na strani prihodka ni kaj izločati: medpodjetniški račun ni bil nikoli v dnevnem posnetku.',
        eliminations_title:        'Izločitve med družbami',
        eliminations_totals_only:  'Odšteta je samo v vsoti skupine; v teh vrsticah obe strani računa nista v isti vrstici.',
        errors_hint:               'Teh hiš ni bilo mogoče prebrati. Njihove številke manjkajo.',
        errors_title:              'Neprebrane hiše',
        excluded_hint:             'Te hiše storitev ni vštela v vsoto skupine.',
        excluded_title:            'Izvzete hiše',
        fold_company:              'Po družbah',
        fold_group:                'Skupina',
        fold_house:                'Po hišah',
        houses_short:              'hiš: {count}',
        legend_currency:           '{currency} je valuta poročanja · tuje valute po mesečnem tečaju ({month})',
        legend_light:              'Izkaz je LIGHT: prihodek manj material manj delo. Energija, najemnine, provizije in amortizacija niso vštete.',
        month:                     'Mesec',
        nights_short:              'sobo-noči: {nights}',
        no_data:                   'Za ta mesec ni podatkov',
        no_nights_hint:            'V tem mesecu ni prodane sobo-noči.',
        no_plan_hint:              'Za to hišo in mesec načrt ni vpisan.',
        open_house:                'Odpri poročila',
        people_without_cost:       'brez stroška: {count}',
        reason_missing:            'Nočni zaključek za ta mesec ni tekel — hiša ni v vsoti.',
        reason_no_rate:            'Za valuto hiše ta mesec ni tečaja — vpiši ga v Tečaji.',
        revenue_split:             'sobe {room} · hrana {fnb}',
        status_missing:            'Brez zaključka',
        status_no_rate:            'Brez tečaja',
        status_ok:                 'V redu',
        subtitle:                  'Prihodek manj material manj delo (light)',
        table_company:             'Po družbah',
        table_group:               'Skupina',
        table_hint:                'Vse v valuti poročanja. „—“ pomeni, da številke ni — ne da je nič.',
        table_house:               'Po hišah',
        tile_labour:               'Delo',
        tile_labour_hint:          '{share} prihodka',
        tile_margin:               'Marža (light)',
        tile_margin_hint:          'Prihodek manj material manj delo',
        tile_margin_share:         'Marža %',
        tile_margin_share_hint:    'delež prihodka',
        tile_materials:            'Material',
        tile_materials_hint:       '{share} prihodka',
        tile_per_night:            'Prihodek na sobo-noč',
        tile_per_night_hint:       'sobo-noči: {nights}',
        tile_revenue:              'Prihodek',
        tile_revenue_hint:         'hiš v vsoti: {count}',
        title:                     'Izkaz',
        total_row:                 'Skupina (v vsoti {counted} od {total})',
        unknown_labour:            'Strošek dela ni prebran.',
        unknown_margin:            'Marže ni: eden od stroškov ni prebran.',
        unknown_materials:         'Poraba materiala ni prebrana.',
        whole_group:               'Cela skupina',
    },

    materials: {
        column_consumption:   'Poraba',
        column_contract:      'Pogodba',
        column_contracts:     'Pogodbe',
        column_house:         'Hiša',
        column_houses:        'Hiše',
        column_late:          'Zamude',
        column_overdue:       'Zapadlo',
        column_per_night:     'Na sobo-noč',
        column_spend:         'Poraba',
        column_status:        'Stanje',
        column_supplier:      'Dobavitelj',
        column_variance:      'Odstopanje',
        contract_chain:       'pogodba verige',
        contract_expiring:    'poteče v 30 dneh',
        contract_mixed:       'hišna in verižna',
        contract_none:        'brez pogodbe',
        contract_property:    'hišna pogodba',
        days_late:            'povprečno {days} dni',
        errors_hint:          'Teh hiš ni bilo mogoče prebrati; njihove številke niso nikjer v tem odgovoru.',
        errors_title:         'Neprebrane hiše',
        excluded_hint:        'Te hiše storitev ni vštela v vsoto skupine in ne v sešteveke dobaviteljev.',
        excluded_title:       'Izvzete hiše',
        expiring_short:       'poteče: {count}',
        invoices_short:       'papirjev: {count}',
        legend_currency:      '{currency} je valuta poročanja · tuje valute po mesečnem tečaju ({month})',
        legend_overdue:       'zapadlo = knjižen račun z dnem plačila v preteklosti, brez dobropisa; plačila ta sistem ne vodi',
        legend_spend:         'poraba so vrstice prevzemov meseca, ne računi',
        legend_suppliers:     'združeno po davčni številki · največ 50 dobaviteljev, po porabi navzdol',
        lines_short:          'vrstic: {lines} od {priced}',
        max_late:             'najdlje {days} dni',
        month:                'Mesec',
        nights_short:         'sobo-noči: {nights}',
        no_data:              'Za ta mesec ni podatkov',
        no_suppliers:         'Ta mesec ni nobenega prevzema',
        open_house:           'Odpri nabavo',
        status_no_rate:       'brez tečaja',
        status_ok:            'v vsoti',
        subtitle:             'nabava skupine po mesecu',
        table_houses:         'Po hišah',
        table_houses_hint:    'Mesec nabave po hišah, v valuti poročanja.',
        table_suppliers:      'Po dobaviteljih',
        table_suppliers_hint: 'Isto podjetje čez vse hiše, združeno po davčni številki.',
        tile_consumption:      'Poraba materiala',
        tile_consumption_hint: 'hiš v vsoti: {count}',
        tile_expiring:         'Pogodbe potečejo',
        tile_expiring_hint:    'aktivnih pogodb: {count}',
        tile_late:             'Zamude dobav',
        tile_late_hint:        'od dobav z obljubljenim dnem',
        tile_overdue:          'Zapadli računi',
        tile_overdue_hint:     'papirjev: {count} · brez stanja plačila',
        tile_per_night:        'Strošek na sobo-noč',
        tile_per_night_hint:   'sobo-noči: {nights}',
        tile_variance:         'Cenovna odstopanja',
        tile_variance_hint:    'vrstic: {lines} od {priced} scenjenih',
        title:                'Nabava',
        total_row:            'Skupina ({counted} od {total} hiš)',
        unkeyed_hint:         'brez davčne številke — združeno po imenu',
        variance_lines_short: 'vrstic: {count}',
    },

    staff: {
        column_absence:          'Odsotnost',
        column_balance:          'Razlika',
        column_cost:             'Strošek dela',
        column_cost_per_night:   'Na sobo-noč',
        column_department:       'Oddelek',
        column_fte:              'FTE',
        column_headcount:        'Zaposleni',
        column_hours_per_night:  'Ure na sobo-noč',
        column_house:            'Hiša',
        column_overtime:         'Nadure',
        column_status:           'Stanje',
        column_worked:           'Opravljeno',
        cost_floor_short:        'strošek ni znan ({count} oseb)',
        errors_hint:             'Teh hiš ni bilo mogoče prebrati; njihovih številk ni nikjer v tem odgovoru.',
        errors_title:            'Neprebrane hiše',
        excluded_hint:           'Teh hiš storitev ni vštela v vsoto skupine in ne v sešteveke oddelkov.',
        excluded_title:          'Izvzete hiše',
        expected_short:          'dolžan: {hours}',
        legend_cost:             'strošek dela je POVPREČJE delovnega mesta iz šifranta hiše, ne plača — obračun plač je drugje',
        legend_currency:         '{currency} je valuta poročanja · tuje valute po mesečnem tečaju ({month})',
        legend_departments:      'združeno po imenu oddelka · ure in strošek samo iz hiš, ki so v vsoti skupine',
        legend_two_cuts:         'zaposleni so matična hiša (kjer je kartica), ure pa hiša žigov — posojena oseba je šteta enkrat v vsaki',
        month:                   'Mesec',
        month_open_badge:        'mesec še ni zaključen',
        month_open_short:        'odprt mesec',
        nights_short:            'sobo-noči: {nights}',
        no_data:                 'Za ta mesec ni podatkov',
        no_department:           'Brez oddelka',
        no_departments:          'Ta mesec ni nobenih ur po oddelkih',
        no_nights:               'ta mesec ni prodane nobene sobo-noči',
        open_house:              'Odpri kadrovsko',
        status_no_rate:          'brez tečaja',
        status_ok:               'v vsoti',
        subtitle:                'kadrovski kazalniki skupine po mesecu',
        table_departments:       'Po oddelkih',
        table_departments_hint:  'Isti oddelek čez vse hiše, združen po imenu. Največ 50 vrstic, po urah navzdol.',
        table_houses:            'Po hišah',
        table_houses_hint:       'Mesec kadrov po hišah, v valuti poročanja.',
        tile_absence:            'Odsotnost',
        tile_absence_hint:       'ur odsotnosti: {hours}',
        tile_cost:               'Strošek dela',
        tile_cost_floor:         'strošek ni znan — {count} oseb brez cene delovnega mesta',
        tile_cost_hint:          'modelirano po delovnih mestih, v {currency}',
        tile_cost_per_night:     'Strošek na sobo-noč',
        tile_cost_per_night_hint: 'sobo-noči: {nights}',
        tile_fte:                'Polna delovna mesta',
        tile_fte_hint:           'polni teden je {hours} ur',
        tile_headcount:          'Zaposleni',
        tile_headcount_hint:     'hiš v vsoti: {count}',
        tile_hours_per_night:    'Ure na sobo-noč',
        tile_hours_per_night_hint: 'sobo-noči: {nights}',
        tile_overtime:           'Nadure',
        tile_overtime_hint:      'sešteto po osebah, ne po hiši · ni pravna opredelitev',
        tile_worked:             'Opravljene ure',
        tile_worked_hint:        'dolžan: {expected}',
        title:                   'Kadri',
        total_row:               'Skupina ({counted} od {total} hiš)',
        trend_cost:              'Strošek dela po mesecih',
        trend_hint:              'zadnjih {count} mesecev',
        trend_worked:            'Opravljene ure po mesecih',
    },

    close: {
        blocked_read_failed:  'branje ni uspelo pri {count} hišah',
        blocked_title:        'Meseca še ni mogoče zaključiti',
        closed_title:         '{month} je zaključen — {at}',
        closed_toast:         'Mesec {month} je zaključen',
        column_closed_at:     'Zaključeno',
        column_house:         'Hiša',
        column_houses:        'Hiš',
        column_month:         'Mesec',
        column_note:          'Zaznamek',
        column_state:         'Stanje',
        confirm:              'Res želite zaključiti {month} za vseh {houses} hiš? Po zaključku so to številke, ki jih skupina pošlje naprej.',
        errors_hint:          'Dokler hiše ni mogoče prebrati, meseca ni mogoče zaključiti — njen mesec je lahko prav tako odprt.',
        errors_title:         'Hiš ni bilo mogoče prebrati',
        failed:               'Meseca ni bilo mogoče zaključiti',
        history_line:         'Zaključeno {closed}, ponovno odprto {reopened}:',
        history_title:        'Prejšnji zaključki tega meseca',
        key_ap_export:        'Izvoz v računovodstvo',
        key_fx_rate_missing:  'Tečaj',
        key_intercompany:     'Prenosi med družbami',
        key_materials_month:  'Materialni mesec',
        key_night_audits:     'Nočni zaključki',
        key_read_failed:      'Branje hiše',
        key_time_month:       'Evidenca časa',
        legend_click:         'Klik na celico odpre zaslon v hiši, ki jo zapre.',
        legend_modules:       'Prazna celica pomeni, da najemnik tega modula nima — ne, da je vse v redu.',
        month:                'Mesec',
        needs_finance:        'Za zaključek potrebujete pravico group:finance ali group:manage.',
        no_data:              'V obsegu ni hiš.',
        no_note:              'Brez zaznamka',
        no_reason:            'Brez razloga',
        note:                 'Zaznamek',
        note_hint:            'Kar je vredno prebrati čez leto dni: zakaj je bil mesec zaključen prav tako.',
        past_empty:           'Skupina še ni zaključila nobenega meseca.',
        past_hint:            'Kaj je skupina razglasila za končano in kdaj.',
        past_title:           'Zaključeni meseci',
        reason:               'Razlog',
        reopen:               'Ponovno odpri',
        reopen_failed:        'Meseca ni bilo mogoče ponovno odpreti',
        reopen_hint:          'Zaključen mesec je že poročan naprej. Razlog je tisto, po čemer bo nekdo čez leto dni vprašal.',
        reopen_title:         'Ponovno odpri mesec skupine',
        reopened_title:       'Ponovno odprto {at}',
        reopened_toast:       'Mesec {month} je ponovno odprt',
        state_blocked:        'Blokirano',
        state_closed:         'Zaključeno',
        state_hint:           'Ali je mesec skupine zaključen, in kaj o tem piše.',
        state_open:           'Odprto',
        state_reopened:       'Ponovno odprto',
        state_title:          'Stanje meseca',
        status_blocking:      'blokira',
        status_ok:            'v redu',
        status_warning:       'opozorilo',
        submit:               'Zaključi mesec',
        subtitle:             'Kaj še manjka, preden je mesec skupine končan',
        table_hint:           'Ena vrstica na hišo, en stolpec na vir. Vrstica je obarvana po svoji najslabši celici.',
        table_title:          'Po hišah',
        tile_blocking:        'Blokira',
        tile_blocking_hint:   'hiš, ki ustavijo zaključek',
        tile_houses:          'Hiše',
        tile_houses_hint:     'v obsegu za {month}',
        tile_ok:              'V redu',
        tile_ok_hint:         'hiš brez pripomb',
        tile_warnings:        'Opozorila',
        tile_warnings_hint:   'hiš z opozorilom, ki ne blokira',
        title:                'Zaključek meseca',
    },

    fx: {
        column_currency:      'Valuta',
        column_entered_by:    'Vpisal',
        column_month:         'Mesec',
        column_rate:          'Tečaj (1 enota v {report})',
        column_source:        'Vir',
        currency_confirm:     'Res želite zamenjati valuto poročanja iz {from} v {to}? Vse doslej združene številke skupine so v {from}.',
        currency_saved:       'Valuta poročanja je {currency}',
        dialog_title:         'Vpiši tečaj',
        enter:                'Vpiši',
        full_time_week:       'Polni delovni teden',
        full_time_week_hint:  'Ur na teden, ki v tej skupini pomenijo polno delovno mesto. Po njih se računa FTE na zaslonu Kadri.',
        legend_manual:        'tečaj vpiše kontroler; objavljeni tečaj je le predlog',
        legend_missing:       'mesec brez tečaja — te hiše tisti mesec ni v vsoti skupine',
        mail_property:        'Hiša pošiljateljica',
        mail_property_hint:   'Poročila gredo po e-pošti prek nastavitev SMTP te hiše.',
        mail_property_none:   'Ni izbrana',
        missing:              'ni vpisan',
        no_currencies:        'Vse hiše poslujejo v valuti poročanja — ni česa preračunavati.',
        no_suggestion:        'Brez predloga',
        rate:                 'Tečaj (1 {currency} v {report})',
        rate_hint:            'Koliko {report} je vredna ena enota {currency} v tem mesecu.',
        report_currency:      'Valuta poročanja',
        report_currency_hint: 'Valuta, v kateri so vse združene številke skupine.',
        saved:                'Tečaj {currency} za {month} je shranjen',
        settings_hint:        'V čem skupina šteje in po kateri uri se ji konča dan.',
        settings_title:       'Nastavitve skupine',
        source:               'Vir',
        source_hint:          'Od kod je tečaj — „NBS, 1. 9.“. Tečaja brez vira čez pol leta nihče ne zna zagovarjati.',
        subtitle:             'mesečni tečaji za poročanje',
        suggestion:           'Predlog {source} {rate} z dne {date}',
        suggestion_hint:      'Predlog ni shranjen, dokler ga ne potrdite.',
        table_hint:           'Trije meseci nazaj in trije naprej. Vsi tečaji so v {report}.',
        table_title:          'Tečaji po valutah in mesecih',
        timezone:             'Časovni pas',
        title:                'Tečaji',
    },

    channels: {
        as_of:                  'osveženo {time}',
        column_connection:      'Povezava',
        column_health:          'Stanje',
        column_house:           'Hiša',
        column_last_error:      'Zadnja napaka',
        column_last_push:       'Zadnji potisk',
        column_no_room:         'Brez sobe',
        column_queue:           'Čakajo / neuspeli',
        errors_hint:            'Teh hiš ni bilo mogoče prebrati, zato niso v nobeni ploščici zgoraj.',
        errors_title:           'Neprebrane hiše',
        full_sync_owed:         'dolguje poln prenos',
        health_error:           'napaka',
        health_none:            'brez kanalov',
        health_ok:              'v redu',
        health_warning:         'opozorilo',
        legend_none:            '„brez kanalov“ ni napaka: hiša prodaja svoje sobe sama',
        legend_queue:           'leva številka so datumi v čakanju, desna tisti, ki jih je agregator zavrnil',
        never_pushed:           'še nikoli',
        no_connections:         'ni povezave',
        no_rows:                'V tem obsegu ni hiš',
        open:                   'Odpri kanale',
        push_delta:             'spremembe',
        push_full:              'poln prenos',
        state_connected:        'povezano',
        state_draft:            'osnutek',
        state_error:            'napaka',
        state_suspended:        'zaustavljeno',
        subtitle:               'ali skupina še prodaja',
        table_hint:             'Ena vrstica na hišo. Popravi se v recepciji hiše, ne tukaj.',
        table_title:            'Po hišah',
        tile_connections:       'Povezave',
        tile_connections_hint:  'vseh povezav v obsegu',
        tile_errors:            'Napake',
        tile_errors_hint:       'zavrnjenih datumov: {count}',
        tile_houses:            'Hiše',
        tile_houses_hint:       'povezav: {count}',
        tile_no_room:           'Rezervacije brez sobe',
        tile_no_room_hint:      'prišle s kanalov, čakajo na recepciji',
        tile_warnings:          'Opozorila',
        tile_warnings_hint:     'hiše, kjer nekaj zastaja',
        title:                  'Kanali',
    },

    alerts: {
        chip_all:         'Vse',
        next:             'Odpri v recepciji',
        none:             'Nič ne čaka. V tem obsegu ni odprtih opozoril.',
        panel_controller: 'Kontroler',
        panel_count:      'vrstic: {count}',
        panel_director:   'Direktor',
        panel_empty:      'Nič ne čaka',
        panel_sales:      'Prodaja',
        pill_critical:    'nujnih: {count}',
        pill_refreshed:   'osveženo {time}',
        pill_warning:     'opozoril: {count}',
        subtitle:         'kaj me čaka',
        title:            'Opozorila',
    },

    operations: {
        badge_redacted:      '{count} zakritih',
        badge_redacted_hint: 'Hiše tega opravila, ki jih vaš obseg ne zajema. Izid zanje ni prikazan.',
        badge_running:       'v teku',
        claimed:             'Opravilo je zagnano; hiše še niso odgovorile.',
        kind_rebuild:        'Obnova posnetkov',
        no_data:             'Ni zapisov o skupinskih opravilih',
        no_targets:          'To opravilo ni zajelo nobene hiše.',
        requested:           '{who} · {when}',
        retry:               'Ponovi neuspele',
        retry_confirm:       'Ponovim opravilo „{kind}“ za hiše, ki ga niso sprejele (hiš: {count})?',
        retry_failed:        'Ponovitve ni bilo mogoče zagnati.',
        retry_hint:          'Isti pritisk še enkrat, samo za hiše, ki ga niso sprejele.',
        retry_started:       'Ponovitev je zagnana.',
        show_targets:        'Po hišah (hiš: {count})',
        status_failed:       'napaka',
        status_ok:           'v redu',
        status_running:      'v teku',
        status_skipped:      'preskočeno',
        status_unknown:      'brez odgovora',
        subtitle:            'kaj je skupina zagnala in kako je šlo',
        summary_failed:      '{count} neuspešnih',
        summary_none:        'brez hiš',
        summary_ok:          '{count} v redu',
        summary_running:     'v teku',
        summary_skipped:     '{count} preskočenih',
        title:               'Zapisi',
        unknown_user:        'neznan uporabnik',
    },

    milo: {
        confirm_delete:      'Želite izbrisati ta pogovor?',
        conversations:       'Pogovori',
        disclaimer:          'Milo odgovarja iz podatkov skupine in ničesar ne spreminja. Pred odločitvijo številko preverite na zaslonu, iz katerega je vzeta.',
        example_attention:   'Katere hiše potrebujejo pozornost?',
        example_occupancy:   'Kako je bila včeraj zasedena skupina?',
        example_pickup:      'Koliko imamo na knjigah za november?',
        failed:              'Milo ni mogel odgovoriti.',
        failed_lost:         'Odgovor se je izgubil. Vprašajte znova.',
        failed_timeout:      'Odgovor traja predolgo. Poskusite znova.',
        greeting:            'Sem Milo, pomočnik uprave.',
        intro:               'Vprašajte me o zasedenosti, prihodkih in rezervacijah hiš v izbranem obsegu. Podatke samo berem.',
        new_conversation:    'Nov pogovor',
        no_conversations:    'Pogovorov še ni',
        placeholder:         'Vprašajte Mila …',
        retry:               'Pošlji znova',
        scope_hint:          'Milo odgovarja znotraj tega obsega.',
        send:                'Pošlji',
        still_working:       'Vprašanje čez več hiš lahko traja do minuto.',
        subtitle:            'vprašanja o skupini',
        thinking:            'Berem podatke …',
        title:               'Milo',
        tools:               'Viri ({count})',
        untitled:            'Brez naslova',
    },

    reports: {
        active_hint:          'Izklopljeno poročilo ostane zapisano in ne teče.',
        add_section:          'Dodaj razdelek',
        added:                'Poročilo „{title}“ je dodano',
        attention:            'za pozornost: {count}',
        back:                 'Nazaj na poročila',
        back_to_runs:         'Nazaj na teke',
        confirm_delete:       'Želite izbrisati poročilo „{title}“?',
        date_today:           'Danes',
        date_yesterday:       'Včeraj',
        deleted:              'Poročilo „{title}“ je izbrisano',
        delivered_at:         'poslano {when}',
        delivery_email:       'Pošlji po e-pošti',
        dialog_hint:          'Razdelki, ura in obseg, v katerem poročilo odgovarja.',
        edit_report:          'Uredi poročilo',
        field_active:         'Vklopljeno',
        field_date:           'Dan',
        field_delivery:       'Dostava',
        field_delivery_hint:  'Po e-pošti gre samo povezava na tek, številke ostanejo v konzoli.',
        field_hour:           'Ura',
        field_hour_hint:      'Ura v časovnem pasu skupine.',
        field_minute:         'Minuta',
        field_months:         'Obdobje',
        field_scope:          'Obseg',
        field_scope_hint:     'Za katere hiše poročilo odgovarja.',
        field_sections:       'Razdelki',
        field_sections_hint:  'Vrstni red razdelkov je vrstni red branja.',
        field_title:          'Naslov',
        field_title_hint:     'Kar piše v zadevi e-pošte in na vrhu teka.',
        field_tool:           'Vsebina razdelka',
        field_weekdays:       'Dnevi',
        field_weekdays_hint:  'Dnevi v tednu, ob katerih poročilo teče.',
        last_run:             'zadnji tek {when}',
        move_down:            'Premakni dol',
        move_up:              'Premakni gor',
        narrative:            'Povzetek',
        never_run:            'Še ni teklo',
        new_report:           'Novo poročilo',
        no_runs:              'To poročilo še ni teklo',
        none:                 'Poročil še ni',
        none_hint:            'Poročilo je seznam razdelkov, ki se ob dogovorjeni uri sam sestavi iz hiš v obsegu.',
        off:                  'Izklopljeno',
        on:                   'Vklopljeno',
        open_run:             'Odpri tek',
        remove_section:       'Odstrani razdelek',
        run:                  'Tek',
        run_failed:           'Teka ni bilo mogoče pognati',
        run_now:              'Zaženi zdaj',
        runs:                 'Teki',
        runs_subtitle:        'kdaj je poročilo teklo in kako se je končalo',
        saved:                'Poročilo „{title}“ je shranjeno',
        schedule_daily:       'vsak dan ob {time}',
        schedule_days:        '{days} ob {time}',
        schedule_never:       'brez dneva — poročilo ne teče',
        schedule_workdays:    'vsak delovnik ob {time}',
        scope_all:            'Ves moj obseg',
        scope_all_hint:       'Tudi hiša, ki bo odprta jutri.',
        scope_current:        'Trenutni izbor ({scope})',
        scope_current_hint:   'Zamrznjen seznam hiš — objektov: {count}.',
        scope_narrowed:       'objektov: {count}',
        section_empty:        'Za ta razdelek ni podatkov.',
        section_failed:       'Razdelka ni bilo mogoče sestaviti.',
        section_no_permission: 'Za ta razdelek nimate pravice.',
        section_unknown:      'Tega razdelka ta konzola ne zna izrisati.',
        status_claimed:       'V teku',
        status_delivered:     'Poslano',
        status_failed:        'Napaka',
        status_missed:        'Zamujeno',
        status_not_delivered: 'Ni poslano',
        status_rendered:      'Sestavljeno',
        subtitle:             'jutranje poročilo skupine',
        switched_off:         'Poročilo „{title}“ je izklopljeno',
        switched_on:          'Poročilo „{title}“ je vklopljeno',
        tile_attention:       'Za pozornost',
        tile_attention_hint:  'zadetkov čez vse razdelke',
        tile_due:             'Ura teka',
        tile_due_hint:        'v časovnem pasu skupine',
        tile_rendered:        'Sestavljeno',
        tile_rendered_hint:   'kdaj je bil tek izrisan',
        tile_sections:        'Razdelkov',
        tile_sections_hint:   's podatki: {count}',
        title:                'Poročila',
        tool_kpi_daily:       'Dnevni pregled',
        tool_kpi_daily_hint:  'Zasedenost, ADR, RevPAR in prihodek sob po hišah.',
        tool_live_today:      'Danes v hišah',
        tool_live_today_hint: 'Prihodi, odhodi in nedodeljene sobe, kot stojijo ob teku.',
        tool_overview:        'Kaj me čaka',
        tool_overview_hint:   'Opozorila v treh ploščah — direktor, kontroler, prodaja.',
        tool_pickup:          'Pickup',
        tool_pickup_hint:     'Kaj je na knjigah za prihodnje mesece.',
        tool_tree:            'Struktura skupine',
        tool_tree_hint:       'Enote, hiše in tiste brez družbe.',
    },

    live: {
        column_arrivals:    'Prihodi',
        column_departures:  'Odhodi',
        column_house:       'Hiša',
        column_in_house:    'V hiši',
        column_night_audit: 'Zadnji nočni zaključek',
        column_unassigned:  'Nedodeljene sobe',
        never_closed:       'še nikoli',
    },

    tree: {
        houses:     'hiš: {count}',
        no_company: 'brez družbe: {count}',
        no_unit:    'Brez enote',
        units:      'enot: {count}',
        unassigned: 'brez družbe',
    },

    rebuild: {
        action:         'Obnovi posnetke',
        done:           'Zapisanih dni: {written}',
        done_missing:   'Brez podatkov: {missing}. Za te dneve hiša nima nočnega zaključka.',
        failed:         'Obnove ni bilo mogoče izvesti',
        from:           'Od',
        from_hint:      'Prvi dan, ki se prebere znova.',
        scope_group:    'Obnova zajame vse hiše, ki jih smete videti.',
        scope_selected: 'Obnova zajame izbrane hiše (hiš: {count}).',
        submit:         'Obnovi',
        subtitle:       'Ponovno prebere dneve iz hiš in osveži združene številke.',
        title:          'Obnovi posnetke',
        to:             'Do',
        to_hint:        'Zadnji dan, ki se prebere znova. Vključen.',
    },

    entity: {
        accounting_none:              'Brez',
        accounting_organisation:      'Oznaka organizacije',
        accounting_organisation_hint: 'Kako to družbo imenuje knjigovodski sistem.',
        accounting_system:            'Knjigovodski sistem',
        accounting_system_hint:       'Kam gredo izvozi te družbe. Brez pomeni, da se še ne izvaža.',
        active:                       'Aktivna',
        active_hint:                  'Neaktivne družbe ni več mogoče izbrati pri prenosu objekta.',
        active_no:                    'Ne',
        active_yes:                   'Da',
        add:                          'Dodaj družbo',
        address_country:              'Država naslova',
        address_country_hint:         'Praviloma enaka državi družbe, a ne nujno.',
        added:                        'Družba je dodana',
        bic:                          'BIC',
        city:                         'Kraj',
        country:                      'Država',
        country_currency:             'Država / valuta',
        currency:                     'Valuta',
        currency_hint:                'Valuta, v kateri ta družba vodi knjige (EUR, HRK …).',
        delete_confirm:               'Res želite izbrisati družbo „{name}“?',
        deleted:                      'Družba je izbrisana',
        dialog_hint:                  'Družba je matični vir imena, davčne in IBAN. Račun vseeno natisne identiteto objekta.',
        drift:                        'Razhajanja',
        drift_entity_value:           'Pri družbi',
        drift_hint:                   'Kje se identiteta objekta razlikuje od zapisa njegove družbe. Kateri je pravi, ve le človek: objekt popravite v recepciji, družbo tukaj.',
        drift_none:                   'Ni razhajanj',
        drift_property_value:         'Pri objektu',
        drift_title:                  'Razhajanja z objekti',
        edit:                         'Uredi družbo',
        field_address:                'Naslov',
        field_bic:                    'BIC',
        field_country:                'Država',
        field_currency:               'Valuta',
        field_iban:                   'IBAN',
        field_name:                   'Ime',
        field_registration_number:    'Matična številka',
        field_short_name:             'Kratko ime',
        field_tax_number:             'Davčna številka',
        field_vat_id:                 'ID za DDV',
        group_accounting:             'Knjigovodstvo',
        group_bank:                   'Banka',
        group_basic:                  'Osnovno',
        group_tax:                    'Davčno',
        houses:                       'Objekti',
        iban:                         'IBAN',
        name:                         'Ime',
        no_data:                      'Ni vpisanih družb',
        payroll_code:                 'Oznaka za obračun plač',
        payroll_code_hint:            'Kako to družbo imenuje obračun plač. Prazno, dokler plač ne izvažate.',
        postal_code:                  'Poštna številka',
        registration_number:          'Matična številka',
        saved:                        'Družba je shranjena',
        search:                       'Iskanje družbe',
        short_name:                   'Kratko ime',
        short_name_hint:              'Ime, ki ga vidite v izbirnikih, kadar je polno predolgo.',
        street:                       'Ulica in hišna številka',
        subtitle:                     'kdo je lastnik objektov',
        tax_number:                   'Davčna številka',
        tax_number_hint:              'Skupaj z državo je to enolična oznaka družbe.',
        tax_vat:                      'Davčna / ID za DDV',
        title:                        'Družbe',
        vat_id:                       'ID za DDV',
        vat_id_hint:                  'Z oznako države, kot je na računu (SI12345678).',
    },

    structure: {
        add_child:               'Dodaj pod',
        add_unit:                'Dodaj enoto',
        assign:                  'Dodeli družbo',
        delete_confirm:          'Res želite izbrisati enoto „{name}“?',
        edit_unit:               'Uredi enoto',
        houses_count:            'objektov: {count}',
        kind_brand:              'Znamka',
        kind_region:             'Regija',
        move:                    'Premakni v enoto',
        move_hint:               'Kam ta objekt poroča. Na poslovanje objekta to ne vpliva.',
        move_title:              'Premakni v enoto',
        moved:                   'Objekt je premaknjen',
        no_company:              'brez družbe',
        pick_unit:               'Izberite enoto',
        rename:                  'Preimenuj',
        subtitle:                'kdo komu poroča',
        title:                   'Struktura',
        unassigned_houses:       'Nerazporejeni objekti',
        unassigned_houses_hint:  'niso v nobeni enoti',
        unit:                    'Enota',
        unit_added:              'Enota je dodana',
        unit_deleted:            'Enota je izbrisana',
        unit_kind:               'Vrsta',
        unit_kind_hint:          'Regija je geografija, znamka je način prodaje. Objekt poroča skozi eno ali drugo, nikoli skozi obe.',
        unit_name:               'Ime enote',
        unit_parent:             'Nadrejena enota',
        unit_parent_hint:        'Drevo je globoko največ dve ravni: skupina → regija ali znamka → objekt.',
        unit_saved:              'Enota je shranjena',
        unit_sort:               'Vrstni red',
        unit_sort_hint:          'Manjša številka je višje na seznamu.',
    },

    transfer: {
        company:              'Nova družba',
        company_hint:         'Lastnica objekta od izbranega datuma naprej.',
        current_company:      'Trenutna družba',
        done:                 'Objekt je prenesen',
        failed:               'Prenosa ni bilo mogoče izvesti',
        history:              'Kaj se zgodi z zgodovino',
        history_follows:      'Celotna zgodovina sledi objektu',
        history_follows_hint: 'Vsa pretekla obdobja se berejo kot obdobja nove družbe. Za preureditev znotraj istega holdinga.',
        history_stays:        'Pretekla obdobja ostanejo pri prejšnji družbi',
        history_stays_hint:   'Kar je bilo knjiženo pod staro družbo, ostane njeno; nova šteje od datuma naprej. Za prodajo objekta.',
        no_company:           'ni dodeljena',
        pick_company:         'Izberite družbo',
        new_company:          'Nova družba',
        submit:               'Prenesi',
        title:                'Dodeli družbo',
        valid_from:           'Velja od',
        valid_from_hint:      'Prvi dan, ki ga šteje nova družba.',
    },

    accounting: {
        add_row:                 'Dodaj vrstico',
        column_already_sent:     'Že poslano',
        column_category:         'Kategorija',
        column_cogs:             'Nabavna vrednost',
        column_consumption:      'Poraba',
        column_cost_centre:      'Stroškovno mesto',
        column_drafts:           'Osnutki',
        column_house:            'Hiša',
        column_inventory:        'Zaloga',
        column_invoices:         'Računi',
        column_items:            'Artikli',
        column_last_export:      'Zadnji izvoz',
        column_lines:            'Vrstice',
        column_note:             'Opomba',
        column_organisation:     'Organizacija',
        column_period:           'Obdobje',
        column_sent_at:          'Poslano',
        column_state:            'Stanje',
        column_unallocated:      'Brez analitike',
        company:                 'Družba',
        coverage:                'Pokritost po hišah',
        coverage_hint:           'Katero pravilo odgovori za vsako kategorijo v posamezni hiši. Kar nima odgovora nikjer, se knjiži na prazen konto.',
        from:                    'Od',
        history:                 'Zgodovina oddaj',
        history_hint:            'Kaj so hiše te družbe že oddale, od najnovejšega.',
        houses:                  'Hiše družbe',
        houses_hint:             'Vsaka hiša pošlje s svojimi poverilnicami. Uprava jih ne vidi in jih ne more spremeniti.',
        legend_blocked:          'Siva vrstica: pritisk te hiše ne doseže.',
        legend_company:          'Značka „družba“: odgovorila je preslikava družbe.',
        legend_drafts:           'Osnutki še niso v knjigah — knjigovodja jim mora dodati odhodek.',
        legend_house:            'Značka „hiša“: hiša ima svojo vrstico in družba je ne more prevoziti.',
        legend_none:             'Značka „manjka“: ni je nikjer — ta kategorija se knjiži na prazen konto.',
        legend_ready:            'Zelena značka: hiša ima poverilnice in pravo organizacijo.',
        map:                     'Kontna preslikava družbe',
        map_failed:              'Preslikave ni bilo mogoče shraniti',
        map_footer:              'Preslikava družbe odgovori samo tam, kjer hiša nima svoje vrstice. Vrstica, ki jo odstranite s te tabele, se ob shranjevanju izbriše.',
        map_hint:                'Zapolni vrzeli hiš. Kjer ima hiša svojo preslikavo, ta vrstica ne velja.',
        map_saved:               'Preslikava je shranjena',
        no_coverage:             'Ni hiš s kategorijami',
        no_history:              'Ta družba še ni ničesar oddala',
        no_houses:               'Ta družba v obsegu nima hiš',
        no_map:                  'Družba nima preslikav',
        not_sent:                'ni poslano',
        open_house:              'Odpri knjigovodstvo hiše',
        organisation_expected:   'družba piše v {organisation}',
        organisation_unset:      'ni vpisana',
        pick_company:            'Izberite družbo',
        pick_company_hint:       'Izberite družbo, katere nabavo želite oddati knjigovodstvu.',
        refusals:                'Za dokončanje',
        refusals_hint:           'Kaj je zadnja oddaja pustila odprto pri knjigovodji.',
        send:                    'Pošlji v knjigovodstvo',
        send_done:               'Poslano: {sent} od {houses} hiš',
        send_failed:             'Pošiljanja ni bilo mogoče izvesti',
        send_houses:             'Pritisk doseže {ready} od {houses} hiš.',
        send_skipped:            'Izpuščenih hiš: {count}',
        send_subtitle:           'Vsaka hiša pošlje s svojimi poverilnicami, ena za drugo.',
        send_title:              'Pošlji v knjigovodstvo',
        source_company:          'družba',
        source_department:       'oddelek',
        source_house:            'hiša',
        source_item:             'artikel',
        source_none:             'manjka',
        state_mismatch:          'Druga organizacija',
        state_not_ready:         'Brez poverilnic',
        state_ready:             'Pripravljeno',
        subtitle:                'nabava družbe h knjigovodji',
        system_file:             'Knjigovodstvo: datoteka. Pošiljanje v Minimax ni na voljo.',
        system_minimax:          'Minimax, organizacija {organisation}',
        system_none:             'Knjigovodski sistem ni izbran. Družbo uredite na zaslonu Družbe.',
        tab_export:              'Izvoz',
        tab_map:                 'Kontna preslikava',
        target_ok:               'poslano',
        tile_attention:          'Za pregled',
        tile_attention_hint:     'hiše, ki jih pritisk ne doseže',
        tile_houses:             'Hiše',
        tile_houses_hint:        'pripravljenih: {ready}',
        tile_invoices:           'Računi v obdobju',
        tile_invoices_hint:      'knjiženi prejeti računi',
        tile_lines:              'Vrstice',
        tile_lines_hint:         'postavke teh računov',
        title:                   'Knjigovodstvo',
        to:                      'Do',
        unreadable:              'Hiš ni bilo mogoče prebrati',
    },

    contract: {
        activate:                'Aktiviraj',
        activated:              'Pogodba „{name}“ je aktivirana',
        allotment:               'Kontingent',
        allotment_hint:          'Koliko sob na noč sme podjetje vzeti v posamezni hiši in koliko dni pred prihodom se nevzeto vrne v prodajo. Zapisano je, ne pa tudi uveljavljeno — rezervacija se ob tem ne ustavi.',
        allotment_release:       'dni sprostitve',
        allotment_rooms:         'sob na noč',
        any_company:             'Vsa podjetja',
        any_status:              'Vsa stanja',
        code_houses:             'hiš: {count}',
        column_actions:          'Dejanja',
        column_active_contracts: 'Aktivne pogodbe',
        column_code:             'Koda cenika',
        column_company:          'Podjetje',
        column_houses:           'Hiše',
        column_name:             'Naziv',
        column_nights:           'Nočitve',
        column_revenue:          'Prihodek',
        column_status:           'Stanje',
        column_validity:         'Veljavnost',
        company:                 'Podjetje',
        company_hint:            'Pogodba je z enim podjetjem, tudi kadar pokriva devet hiš.',
        company_placeholder:     'Poišči podjetje …',
        company_refused:         'Registra podjetij ni bilo mogoče prebrati',
        company_required:        'Izberite podjetje',
        contact_email:           'E-pošta kontakta',
        contact_name:            'Kontaktna oseba',
        contact_phone:           'Telefon kontakta',
        created:                'Osnutek pogodbe „{name}“ je shranjen',
        credit_limit:            'Kreditni limit',
        credit_limit_hint:       'Nič pomeni brez omejitve.',
        delete_confirm:         'Izbrišem osnutek pogodbe „{name}“?',
        deleted:                'Osnutek „{name}“ je izbrisan',
        dialog_edit:             'Uredi pogodbo',
        dialog_hint:             'Pogodba se rodi kot osnutek. Aktivira se s svojim gumbom, ker se takrat preveri, ali cenik s to kodo obstaja v vseh hišah.',
        dialog_new:              'Nova pogodba',
        end:                     'Zaključi',
        end_reason:              'Razlog zaključka',
        end_reason_hint:         'Zakaj se pogodba konča. Zapisano ostane — čez leto dni je to prvo, kar kdo prebere.',
        end_title:               'Zaključek pogodbe',
        ended:                  'Pogodba „{name}“ je zaključena',
        errors_hint:             'Te hiše niso odgovorile. Njihovih številk v vsotah ni.',
        errors_title:            'Neprebrane hiše',
        excluded_hint:           'Te hiše so ostale brez denarja, ker za njihovo valuto ni vpisanega tečaja. Nočitve so ostale.',
        excluded_title:          'Izpuščene hiše',
        expand:                  'Razpri hiše',
        filter_company:          'Podjetje',
        filter_status:           'Stanje',
        from:                    'Od',
        houses:                  'Hiše',
        houses_all:              'Vse hiše skupine',
        houses_count:            'hiš: {count}',
        houses_hint:             'Prazno pomeni vse hiše skupine — tudi tiste, ki se odprejo pozneje.',
        legend_capped:           'Seznam je odrezan pri dvesto podjetjih.',
        legend_code:             'Rumena vrstica: cenika s to kodo ni v vseh hišah pogodbe.',
        legend_currency:         'Zneski so v {currency}, pretvorjeni po tečaju meseca, ki mu denar pripada.',
        legend_ended:            'Zaključene pogodbe ostanejo — pojasnjujejo cene na že izdanih računih.',
        legend_nights:           'Nočitve se štejejo po prihodu bivanja v obdobje.',
        missing_code:            'cenik manjka v {count} hišah',
        name:                    'Naziv pogodbe',
        new:                     'Nova pogodba',
        nights_short:            'nočitev: {count}',
        no_contracts:            'Ni pogodb',
        no_production:           'V tem obdobju ni podjetniške produkcije',
        notes:                   'Opomba',
        open_end:                'brez konca',
        open_hint:               'Prazno pomeni odprt konec.',
        open_start:              'brez začetka',
        payment_terms:           'Plačilni rok (dni)',
        payment_terms_hint:      'Nič pomeni privzeti rok podjetja.',
        production_hint:         'Kaj so podjetja dejansko prinesla, po hišah, v valuti poročanja.',
        production_title:        'Produkcija po podjetjih',
        rate_plan_code:          'Koda cenika',
        rate_plan_code_hint:     'Pogodba imenuje cenik s KODO, ne z oznako dokumenta: ista koda pomeni isto ceno v vsaki hiši. Spodaj so kode, ki jih hiše v obsegu res nosijo.',
        saved:                  'Pogodba „{name}“ je shranjena',
        status_active:           'Aktivna',
        status_draft:            'Osnutek',
        status_ended:            'Zaključena',
        status_no_rate:          'ni tečaja',
        subtitle:                'korporativne pogodbe skupine',
        tab_contracts:           'Pogodbe',
        tab_production:          'Produkcija',
        table_hint:              'Kaj je skupina dogovorila, s kom, na katerem ceniku in ali ga vse hiše sploh nosijo.',
        table_title:             'Pogodbe skupine',
        terms:                   'Dogovorjeno',
        terms_days:              'rok {days} dni',
        terms_hint:              'Ugodnosti v besedah, v katerih so bile dogovorjene — zajtrk, pozni odjavi, popust na baru.',
        title:                   'Pogodbe',
        to:                      'Do',
        total_row:               'Skupaj (podjetij: {count})',
        unknown_company:         'Neznano podjetje',
        valid_from:              'Velja od',
        valid_to:                'Velja do',
    },

    intercompany: {
        attention_badge:      'Za pregled',
        book_hint:            'Po parih družb: kaj se je preneslo, kaj je zaračunano in kaj ni ujeto na noben račun.',
        book_title:           'Knjiga meseca',
        buyer:                'Kupka',
        buyer_all:            'Vse kupke',
        buyer_filter:         'Kupka',
        buyer_hint:           'Družba, ki plača.',
        cancel_failed:        'Računa ni bilo mogoče preklicati',
        cancel_hint:          'Izdanega računa ni mogoče spremeniti. Preklic ga pusti v evidenci, a ne velja več.',
        cancel_invoice:       'Prekliči',
        cancel_reason:        'Razlog',
        cancel_reason_hint:   'Zakaj je bil račun preklican. Razlog ostane pri računu.',
        cancel_refused:       'Preklic ni mogoč',
        cancel_title:         'Preklic računa',
        cancelled_toast:      'Račun {number} je preklican',
        column_buyer:         'Kupka',
        column_dates:         'Datum',
        column_drafts:        'Osnutki',
        column_gross:         'Bruto',
        column_issued:        'Izdani',
        column_item:          'Artikel',
        column_markup:        'Pribitek',
        column_mirror:        'Zrcalo',
        column_net:           'Neto',
        column_note:          'Opomba',
        column_number:        'Številka',
        column_parties:       'Prodajalka → kupka',
        column_quantity:      'Količina',
        column_seller:        'Prodajalka',
        column_status:        'Status',
        column_tax:           'DDV',
        column_tax_rate:      'Stopnja',
        column_terms:         'Rok',
        column_transfers:     'Prenosi',
        column_unit_cost:     'Lastna cena',
        column_unit_price:    'Cena',
        column_unmatched:     'Neujeti',
        column_vat_mode:      'Način DDV',
        days:                 '{count} dni',
        document_hash:        'Odtis dokumenta: {hash}',
        draft_number:         'osnutek',
        due_short:            'zapadlost {date}',
        iban:                 'IBAN',
        invoices_hint:        'Medpodjetniški računi izbranega meseca. Klik na vrstico odpre račun.',
        invoices_title:       'Računi',
        issue:                'Izdaj',
        issue_failed:         'Računa ni bilo mogoče izdati',
        issue_note:           'Zaznamek',
        issue_note_hint:      'Neobvezno. Ostane v zapisu o izdaji.',
        issue_title:          'Izdaja računa',
        issued_on:            'Datum izdaje',
        issued_on_hint:       'Dan, ki bo na dokumentu. Številka se rezervira šele ob izdaji.',
        issued_toast:         'Račun {number} je izdan z dnem {date}',
        legend_attention:     'Rumena vrstica: storitev je k računu zapisala opozorilo.',
        legend_currency:      'Znesek je v valuti para, ne v poročevalski valuti.',
        legend_direction:     'Par je usmerjen: prodajalka → kupka.',
        legend_draft:         'Osnutek nima številke — ta se rezervira šele ob izdaji.',
        legend_mirror:        'Zrcalo je prejeti račun kupke; nastane šele po izdaji.',
        legend_unmatched:     'Rumena vrstica: prenos, ki ni na nobenem računu.',
        markup:               'Pribitek (%)',
        markup_hint:          'Odstotek na lastno ceno. 0 % pomeni prodajo po lastni ceni.',
        markup_range:         'Pribitek je med 0 in 100 %.',
        merge:                'Združi izbrane',
        merge_drafts_only:    'Združiti je mogoče samo osnutke.',
        merge_failed:         'Osnutkov ni bilo mogoče združiti',
        merge_need_two:       'Izberite vsaj dva osnutka.',
        merge_one_pair:       'Vsi izbrani osnutki morajo biti istega para in v isti valuti.',
        merged:               'Združenih osnutkov: {count}',
        mirror_badge:         'Zrcalo: {state}',
        mirror_draft:         'Osnutek',
        mirror_matched:       'Ujet',
        mirror_posted:        'Knjižen',
        month:                'Mesec',
        no_invoices:          'V tem mesecu ni računov',
        no_lines:             'Račun nima postavk',
        no_pairs_month:       'V tem mesecu ni prenosov med družbami',
        no_rules:             'Ni dogovorjenih parov',
        no_rules_hint:        'Brez para se prenos med družbama zaračuna po lastni ceni.',
        note:                 'Opomba',
        note_hint:            'Neobvezno. Za koga dogovor velja, od kdaj, kdo ga je sklenil.',
        open_pair:            'Odpri račune tega para',
        operation_id:         'Ime pritiska: {id}',
        pair_add:             'Dodaj par',
        pair_delete_confirm:  'Izbrišem dogovor {seller} → {buyer}? Izdani računi ostanejo, novi osnutki pa bodo brez pribitka.',
        pair_deleted:         'Par {seller} → {buyer} je izbrisan',
        pair_direction:       'Par je usmerjen: prodajalka → kupka. Obratna smer je svoja vrstica s svojim pribitkom.',
        pair_edit:            'Uredi par',
        pair_locked:          'Družb pri urejanju ni mogoče zamenjati — par sta prav ti dve. Za obratno smer dodajte nov par.',
        pair_same_company:    'Prodajalka in kupka morata biti različni družbi.',
        pair_saved:           'Par {seller} → {buyer} je shranjen',
        pairs_hint:           'Dogovor med dvema družbama: pribitek in plačilni rok. Po njem se cenijo postavke novih računov.',
        pairs_title:          'Pari družb',
        payment_terms:        'Plačilni rok (dni)',
        payment_terms_hint:   'Koliko dni po izdaji račun zapade. Največ 120.',
        pdf:                  'PDF',
        pick_company:         'Izberite družbo',
        recapitulative:       'Rekapitulacijsko poročilo',
        recapitulative_hint:  'Ta račun gre v rekapitulacijsko poročilo.',
        recapitulative_short: 'rekapitulacijsko',
        reverse_charge_clause: 'Klavzula',
        select_row:           'Izberi račun',
        seller:               'Prodajalka',
        seller_all:           'Vse prodajalke',
        seller_filter:        'Prodajalka',
        seller_hint:          'Družba, ki zaračuna.',
        status_all:           'Vsi statusi',
        status_cancelled:     'Preklican',
        status_draft:         'Osnutek',
        status_filter:        'Status',
        status_issued:        'Izdan',
        subtitle:             'računi med družbami iz prenosov zaloge',
        tab_book:             'Knjiga',
        tab_invoices:         'Računi',
        tab_pairs:            'Pari',
        tax_number:           'Davčna',
        terms_range:          'Plačilni rok je med 0 in 120 dni.',
        title:                'Medpodjetniško',
        total_row:            'Skupaj ({count} postavk)',
        transfers_short:      'prenosov: {count}',
        vat_domestic:         'Domači DDV',
        vat_id:               'ID za DDV',
        vat_none:             'Brez DDV',
        vat_reverse_charge:   'Obrnjena davčna obveznost',
    },

    rate: {
        action_conflict:                  'Spor',
        action_create:                    'Nov cenik',
        action_update:                    'Posodobitev',
        active_no:                        'Neaktivna',
        active_yes:                       'Aktivna',
        add:                              'Nova predloga',
        add_category:                     'Nova kategorija',
        add_price:                        'Dodaj ceno',
        add_rung:                         'Dodaj stopnjo',
        add_title:                        'Nova predloga cenika',
        added:                            'Predloga {code} je dodana',
        all_templates:                    'Vse predloge',
        board_all_inclusive:              'Vse vključeno',
        board_breakfast:                  'Zajtrk',
        board_full_board:                 'Polni penzion',
        board_half_board:                 'Polpenzion',
        board_none:                       'Brez obrokov',
        bulk_done:                        'Zapisano v {written} od {houses} hiš',
        bulk_failed:                      'Omejitev ni bilo mogoče zapisati',
        bulk_scope:                       'Pritisk doseže {scope} — hiš: {count}.',
        categories:                       'Kategorije sob',
        categories_hint:                  'Besednjak skupine. Predloga ceni kategorijo, hiša nanjo preslika svoje tipe sob.',
        category_active_hint:             'Neaktivna kategorija se novim predlogam ne ponuja, obstoječe preslikave ostanejo.',
        category_add:                     'Nova kategorija sob',
        category_added:                   'Kategorija {code} je dodana',
        category_code_hint:               'Oznaka, ki jo predloga ceni — STD, SUP, SUITE.',
        category_delete_confirm:          'Izbrišem kategorijo „{name}“?',
        category_deleted:                 'Kategorija {code} je izbrisana',
        category_dialog_hint:             'Beseda skupine, ne soba hiše.',
        category_edit:                    'Uredi kategorijo sob',
        category_in_use:                  'Kategorija {code} je še v uporabi — hiše nanjo preslikajo tipe sob. Namesto brisanja jo deaktivirajte.',
        category_saved:                   'Kategorija {code} je shranjena',
        category_sort_hint:               'Mesto v seznamu. Manjša številka je višje.',
        column_action:                    'Dejanje',
        column_active:                    'Aktivna',
        column_board:                     'Obroki',
        column_category:                  'Kategorija',
        column_code:                      'Oznaka',
        column_covered:                   'Pokrite kategorije',
        column_currency:                  'Valuta',
        column_days_before:               'Dni pred prihodom',
        column_deviations:                'Odstopanja cen',
        column_discount:                  'Popust (%)',
        column_house:                     'Hiša',
        column_house_version:             'Različica hiše',
        column_mapped:                    'Preslikanih',
        column_name:                      'Ime',
        column_notes:                     'Opombe',
        column_overrides:                 'Spremembe hiše',
        column_plan:                      'Cenik hiše',
        column_price_extra:               'Dodatna odrasla oseba',
        column_price_standard:            'Standardna zasedenost',
        column_room_types:                'Tipov sob',
        column_room_types_list:           'Tipi sob',
        column_sort:                      'Vrstni red',
        column_template:                  'Predloga',
        column_unmapped:                  'Brez kategorije',
        column_version:                   'Različica',
        coverage:                         'Pokritost po hišah',
        coverage_hint:                    'Kateri tip sobe v posamezni hiši nosi kategorijo in kateri nobene. Tipa brez kategorije potisk ne more oceniti.',
        covered_of:                       'pokritih {covered} od {total}',
        currency_fixed:                   'Valuta predloge',
        currency_house:                   'Hišna valuta',
        delete_confirm:                   'Izbrišem predlogo „{name}“?',
        deleted:                          'Predloga {code} je izbrisana',
        deviation_days:                   '{differing} od {compared} dni',
        dialog_hint:                      'Odločitev skupine. Hiš se dotakne šele potisk.',
        early_booking:                    'Stopnje popusta',
        early_booking_hint:               'Stopnje morajo padati po dnevih: 90 dni prej prinese več kot 30 dni prej.',
        edit_title:                       'Uredi predlogo cenika',
        field_active:                     'Aktivna',
        field_active_hint:                'Neaktivne predloge ni mogoče potisniti.',
        field_apply_prices:               'Zapiši cene',
        field_apply_prices_hint:          'Cene predloge se zapišejo čez okno. Brez tega ostanejo, kar so.',
        field_apply_restrictions:         'Zapiši omejitve',
        field_apply_restrictions_hint:    'Privzete omejitve predloge se zapišejo čez okno.',
        field_board_type:                 'Obroki',
        field_cancellation_name:          'Ime pogojev odpovedi',
        field_cancellation_name_hint:     'Kar gost prebere ob rezervaciji.',
        field_cancellation_policy:        'Pogoji odpovedi',
        field_categories:                 'Kategorije',
        field_categories_hint:            'Brez izbire velja za vse kategorije cenika.',
        field_code:                       'Oznaka',
        field_code_hint:                  'Kratka oznaka, po kateri hiše prepoznajo ta cenik.',
        field_currency:                   'Valuta',
        field_currency_hint:              'Velja samo, kadar valuto določi predloga sama.',
        field_currency_mode:              'Valuta cen',
        field_currency_mode_hint:         'Hišna valuta pomeni, da vsaka hiša prodaja v svoji.',
        field_days_before_arrival:        'Dni pred prihodom',
        field_days_before_arrival_hint:   'Do kdaj je odpoved še brezplačna.',
        field_deadline_hour:              'Ura',
        field_deadline_minute:            'Minuta',
        field_early_booking:              'Zgodnja rezervacija',
        field_fields:                     'Kaj se zapiše',
        field_fields_hint:                'Zapiše se natanko to, kar izberete. Vse drugo na teh dnevih ostane.',
        field_free_cancellation:          'Brezplačna odpoved',
        field_free_cancellation_hint:     'Brez tega je rezervacija nepovratna od potrditve naprej.',
        field_from:                       'Od',
        field_max_stay:                   'Največ noči',
        field_min_advance_booking:        'Najmanj dni vnaprej',
        field_min_stay:                   'Najmanj noči',
        field_name:                       'Ime',
        field_offset:                     'Odmik',
        field_offset_type:                'Vrsta odmika',
        field_offset_value:               'Odmik',
        field_offset_value_amount_hint:   'Vpišete v celi valuti. Na žico gre v centih.',
        field_offset_value_percent_hint:  'Vpišete v odstotkih. Na žico gre v bazičnih točkah.',
        field_parent_code:                'Oznaka nadrejene predloge',
        field_parent_code_hint:           'Izvedena predloga vzame ceno od te in jo premakne za odmik.',
        field_penalty_percent:            'Odstotek kazni',
        field_penalty_percent_hint:       'Vpišete v odstotkih. Na žico gre v bazičnih točkah.',
        field_penalty_type:               'Kazen ob odpovedi',
        field_rate_plan_code:             'Oznaka cenika',
        field_rate_plan_code_hint:        'Zapiše se čez cenik s to oznako v vsaki hiši.',
        field_refundable:                 'Povratna rezervacija',
        field_refundable_hint:            'Nepovraten cenik se plača ob potrditvi in se ne vrača.',
        field_room_categories:            'Kategorije sob',
        field_room_categories_hint:       'Katere kategorije ta predloga ceni. Česar hiša nima, potisk našteje v predogledu.',
        field_template:                   'Predloga',
        field_template_hint:              'Zapiše se čez vse cenike hiš, ki izhajajo iz te predloge.',
        field_to:                         'Do',
        field_type:                       'Vrsta',
        field_weekdays:                   'Dnevi v tednu',
        field_weekdays_hint:              'Brez izbire velja za vse dni v oknu.',
        field_window_hint:                'Okno, čez katero se zapiše. Privzeto leto naprej.',
        fields_hint:                      'Zapiše se natanko to, kar izberete.',
        free_no:                          'Ni brezplačne odpovedi',
        free_yes:                         'Brezplačna odpoved',
        group_basic:                      'Osnovno',
        group_cancellation:               'Odpoved',
        group_categories:                 'Kategorije',
        group_early_booking:              'Zgodnja rezervacija',
        group_price:                      'Cena',
        group_restrictions:               'Restrikcije',
        ladder_decreasing:                'Stopnje morajo padati po dnevih pred prihodom.',
        legend_conflict:                  'Siva vrstica: hiša ima cenik, ki ni iz te predloge.',
        legend_overridden:                'Modra značka: polje, ki ga je hiša spremenila sama.',
        legend_overrides:                 'Modra značka: potisk tega ne povozi.',
        legend_stale:                     'Siva vrstica: cenik nosi starejšo različico predloge.',
        legend_uncovered:                 'Oranžna značka: kategorija, ki je ta hiša nima.',
        legend_unmapped:                  'Oranžna značka: tip sobe brez kategorije — potisk ga ne more oceniti.',
        no_categories:                    'Skupina še nima kategorij sob',
        no_coverage:                      'V tem obsegu ni hiš s tipi sob',
        no_deviation:                     'brez odstopanj',
        no_parity:                        'V tem obsegu ni cenikov iz predlog',
        no_preview_houses:                'V tem obsegu ni hiš',
        no_prices:                        'Predloga še nima cen',
        no_template:                      'Brez predloge',
        no_templates:                     'Skupina še nima predlog cenikov',
        non_refundable:                   'Nepovratno',
        offset_amount:                    'Znesek',
        offset_amount_per_person:         'Znesek na osebo',
        offset_none:                      'Brez odmika',
        offset_percentage:                'Odstotek',
        one_target_required:              'Izberite predlogo ali vpišite oznako cenika — natanko eno od obojega.',
        open_rates:                       'Odpri cenik hiše',
        parent_of:                        'izhaja iz {code}',
        parent_required:                  'Izvedena predloga potrebuje oznako nadrejene.',
        parity:                           'Pariteta cen',
        parity_filter:                    'Predloga',
        parity_hint:                      'Kje so hiše odšle od tega, kar so bile potisnjene.',
        parity_table_hint:                'Ena vrstica na cenik hiše. Odstopanje ni napaka — je vprašanje za hišo.',
        penalty_first_night:              'Prva noč',
        penalty_full_stay:                'Celotno bivanje',
        penalty_none:                     'Brez kazni',
        penalty_percentage:               'Odstotek bivanja',
        pick_categories:                  'Izberite kategorije',
        preview_push:                     'Predogled potiska',
        preview_scope:                    'Obseg: {scope}',
        preview_subtitle:                 '{code}, različica {version}',
        preview_title:                    'Predogled potiska',
        prices:                           'Cene po kategorijah',
        prices_hint:                      'Vpišete v celi valuti. Na žico gre v centih.',
        push:                             'Potisni',
        push_done:                        'Zapisano v {written} od {houses} hiš',
        push_failed:                      'Potiska ni bilo mogoče izvesti',
        push_scope:                       'Pritisk doseže {scope} — hiš: {count}.',
        push_subtitle:                    'Predloga se zapiše v vsako hišo v obsegu.',
        push_template:                    '{code} — {name}, različica {version}',
        push_title:                       'Potisni predlogo v hiše',
        refundable_no:                    'Nepovratno',
        refundable_yes:                   'Povratno',
        remove_rung:                      'Odstrani stopnjo',
        restriction_closed_to_arrival:    'Zaprto za prihode',
        restriction_closed_to_departure:  'Zaprto za odhode',
        restriction_max_stay:             'Največ noči',
        restriction_min_advance_booking:  'Najmanj dni vnaprej',
        restriction_min_stay:             'Najmanj noči',
        restriction_stop_sell:            'Ustavi prodajo',
        restrictions:                     'Skupinski zapis omejitev',
        restrictions_form_hint:           'Eno okno pravil prodaje čez vse hiše v obsegu.',
        restrictions_hint:                'Privzete omejitve, ki jih potisk zapiše skupaj s cenami.',
        saved:                            'Predloga {code} je shranjena',
        subtitle:                         'kaj skupina zaračuna in kaj hiše prodajajo',
        tab_categories:                   'Kategorije',
        tab_parity:                       'Pariteta',
        tab_restrictions:                 'Restrikcije',
        tab_templates:                    'Predloge',
        target_ok:                        'zapisano',
        templates:                        'Predloge cenikov',
        templates_hint:                   'Odločitve skupine. Hiš se dotakne šele potisk.',
        tile_deviations:                  'Odstopanja cen',
        tile_deviations_hint:             'ceniki, ki prodajajo drugače',
        tile_houses:                      'Hiše',
        tile_houses_hint:                 'v obsegu',
        tile_linked_plans:                'Ceniki iz predlog',
        tile_linked_plans_hint:           'povezani ceniki hiš',
        tile_overridden:                  'Spremenjeni',
        tile_overridden_hint:             'ceniki, ki jih je hiša spremenila',
        tile_stale:                       'Zastareli',
        tile_stale_hint:                  'ceniki s starejšo različico',
        title:                            'Ceniki',
        type_derived:                     'Izvedena',
        type_standard:                    'Samostojna',
        unmapped_room_type:               '{code} — brez kategorije',
        unreadable:                       'Hiš ni bilo mogoče prebrati',
        version_badge:                    'v{version}',
        version_current:                  'aktualna',
        version_stale:                    'zastarela — {version} od {current}',
        write:                            'Zapiši v hiše',
    },
    master_groups: {
        add:                   'Nova matična skupina',
        adults:                'Odraslih',
        arrival:               'Prihod',
        back:                  'Nazaj',
        block_add:             'Dodaj tip sobe',
        board_hint:            'Dogovorjeno, držano, prevzeto in sproščeno po hiši in po tipu sobe. Gumba na vrstici delujeta v tisti hiši.',
        board_title:           'Prevzem po hišah',
        cancel_hint:           'Odpoved matične skupine odpove skupino v vsaki hiši prek njene lastne odpovedne poti, ki ovrednoti lestvico in sprosti sobe.',
        cell_state:            'Dogovorjeno {rooms} · držanih {held} · prevzetih {picked} · sproščenih {released}',
        children:              'Otrok',
        column_company:        'Naročnik',
        column_held:           'Držanih',
        column_house:          'Hiša',
        column_houses:         'Hiše',
        column_ladder:         'Lestvica',
        column_link:           'Povezava',
        column_name:           'Naziv',
        column_number:         'Številka',
        column_pending:        'Čaka',
        column_period:         'Obdobje',
        column_picked_up:      'Prevzetih',
        column_price:          'Cena/noč',
        column_released:       'Sproščenih',
        column_rooms:          'Dogovorjeno',
        column_status:         'Stanje',
        company:               'Naročnik',
        company_help:          'Podjetje, ki naroči kongres. Kopira se v vsako hišo kot plačnik njene skupine.',
        company_placeholder:   'Poišči podjetje',
        contact_email:         'E-pošta',
        contact_name:          'Kontakt',
        contact_phone:         'Telefon',
        contract_hint:         'Plačnik, datumi in odpovedna lestvica so pogodbeni: hiša jih ne more več spremeniti sama (koda 126). Uprava jih spremeni tu in se prenesejo.',
        contract_title:        'Pogodba',
        create:                'Ustvari',
        created:               'Matična skupina {number} je ustvarjena',
        created_partly:        'Matična skupina je ustvarjena, {count} hiš je ni sprejelo',
        departure:             'Odhod',
        from:                  'Od prihoda',
        house_unreadable:      'Hiše {house} ni bilo mogoče prebrati',
        ladder_add:            'Dodaj stopnjo',
        ladder_days:           'Dni pred prihodom',
        ladder_differs:        'ni usklajena',
        ladder_hint:           'Prva stopnja, ki jo odpoved doseže, velja. Stopnje morajo padati od najdaljšega odpovednega roka navzdol.',
        ladder_keep:           'Zaračunamo (%)',
        ladder_matches:        'usklajena',
        ladder_order:          'Stopnje morajo padati: vsaka naslednja ima manj dni pred prihodom.',
        ladder_title:          'Odpovedna lestvica',
        legend_board:          'Prevzetih je dogovorjeno minus držanih minus sproščenih.',
        legend_price:          'Cena je dogovorjena cena bloka v valuti hiše in se ne preračunava.',
        legend_rooming:        'Povezava rooming liste je hišna: uprava jih vidi, izda pa jo recepcija tiste hiše.',
        legend_rooms:          'Obarvana vrstica: v vsaj eni hiši skupina ni nastala.',
        legend_sync:           'Obarvana vrstica: hiša ne drži release datuma ali odpovedne lestvice kongresa.',
        legend_unmade:         'Rumena značka hiše pomeni, da v njej skupina ni nastala.',
        link_none:             'Ni povezave',
        link_open:             'Izdana',
        member_add:            'Dodaj hišo',
        member_add_help:       'Hiša iz obsega. Dodana hiša dobi skupino z datumi, plačnikom in lestvico matične skupine.',
        member_failed:         'Hiša {house} ni sprejela pritiska',
        member_pick:           'Izberi hišo …',
        member_remove:         'Odstrani hišo',
        member_unmade:         'V tej hiši skupina ni nastala',
        members_hint:          'Vsaka hiša dobi svojo skupino s svojo številko in svojimi bloki.',
        members_title:         'Hiše in bloki',
        move_cancel:           'Odpovej',
        move_cancel_confirm:   'Odpovem matično skupino in skupino v {count} hišah? Vsaka hiša ovrednoti svojo odpovedno lestvico in sprosti sobe.',
        move_complete:         'Zaključi',
        move_complete_confirm: 'Zaključim matično skupino in skupino v {count} hišah?',
        move_confirm:          'Potrdi',
        move_confirm_confirm:  'Potrdim matično skupino in skupino v {count} hišah?',
        move_failed:           'Stanja ni bilo mogoče spremeniti',
        move_option:           'Na opcijo',
        move_option_confirm:   'Dam matično skupino na opcijo v {count} hišah? Hiše bodo prijele sobe.',
        moved:                 'Stanje je spremenjeno v „{status}“',
        moved_partly:          'Stanje je spremenjeno, {count} hiš ni sledilo',
        name:                  'Naziv',
        name_help:             'Naziv kongresa. Vsaka hiša ga dobi na svojo skupino, da ga recepcija prepozna na svojem seznamu.',
        name_placeholder:      'Kongres SDZP 2026',
        new_hint:              'Ena pogodba, ena skupina v vsaki izbrani hiši.',
        new_title:             'Nova matična skupina',
        nightly_price:         'Cena/noč',
        nightly_price_help:    'Dogovorjena cena na sobo na noč, v valuti te hiše.',
        no_company:            'Brez naročnika',
        no_houses:             'Ni hiš',
        no_room_types:         'Ta hiša nima tipov sob',
        no_rows:               'Ni matičnih skupin',
        notes:                 'Opombe',
        open_reception:        'Odpri v recepciji',
        open_reception_hint:   'Odpre skupino te hiše v njeni recepciji: rooming lista, ponudba, folio in posamezna soba so tam.',
        pickup_do:             'Prevzemi',
        pickup_failed:         'Prevzema ni bilo mogoče izvesti',
        pickup_payer_hint:     'Sobe se prevzamejo na naročnika skupine. Sobo z imenom gosta prevzame recepcija, ki gosta ima.',
        pickup_rooms_help:     'Koliko držanih sob naj postane rezervacija. Vsaka soba je svoje dejanje.',
        pickup_title:          'Prevzem sob',
        release_date:          'Release datum',
        release_date_help:     'Kdaj neprevzete sobe same gredo nazaj v prodajo. Prenese se v vsako hišo.',
        release_do:            'Sprosti',
        release_failed:        'Sprostitve ni bilo mogoče izvesti',
        release_rooms_help:    'Koliko držanih sob naj gre nazaj v prodajo. Dogovorjena količina se ne spremeni.',
        release_title:         'Sprostitev sob',
        resync:                'Ponovno uskladi',
        resync_confirm:        'Ponovno zapišem release datum in odpovedno lestvico kongresa v {count} hiš?',
        resync_failed:         'Uskladitve ni bilo mogoče izvesti',
        resync_hint:           'Zapiše pogodbena dela kongresa v hiše, ki jih niso prevzele. Ne spremeni pogodbe same.',
        resync_one:            'Uskladi',
        resynced:              'Hiše so usklajene s pogodbo kongresa',
        resynced_partly:       'Usklajevanje je izvedeno, {count} hiš ga ni sprejelo',
        room_type:             'Tip sobe',
        rooming_hint:          'Ena povezava na hišo in ne ena za kongres: kateri hiši ime pripada, ve samo hiša, ki ga sprejme.',
        rooming_open_hint:     'Odpre skupino te hiše v njeni recepciji, kjer se rooming lista izda in uskladi.',
        rooming_title:         'Rooming liste',
        rooms:                 'Sob',
        rooms_done:            'Izvedeno: {done} od {asked}',
        status:                'Stanje',
        status_all:            'Vsa stanja',
        status_cancelled:      'Odpovedana',
        status_completed:      'Zaključena',
        status_confirmed:      'Potrjena',
        status_inquiry:        'Povpraševanje',
        status_option:         'Opcija',
        subtitle:              'En kongres čez več hiš',
        sync_drifted:          'Neusklajenih hiš: {count}',
        sync_hint:             'Prenos v hiše je po hišah: hiša, ki je bila takrat nedosegljiva, drži staro pogodbo. Tu je vidno, katera.',
        sync_master_date:      'kongres: {date}',
        sync_title:            'Pogodba po hišah',
        table_hint:            'Ena vrstica je ena pogodba. Klik odpre kongres.',
        table_title:           'Matične skupine',
        tile_held:             'Držanih sob',
        tile_held_hint:        'Prave nočitve v hišah, ne napoved.',
        tile_houses:           'Hiš',
        tile_picked_up:        'Prevzetih sob',
        tile_picked_up_hint:   'Dogovorjeno minus držano minus sproščeno.',
        tile_rooms:            'Dogovorjenih sob',
        tile_rooms_hint:       'Vsota blokov po vseh hišah kongresa.',
        title:                 'Skupine',
        to:                    'Do prihoda',
        total_row:             'Skupaj ({count} hiš)',
    },

    reservations: {
        adults:                  'Odraslih',
        arrival:                 'Prihod',
        book:                    'Rezerviraj',
        booked:                  'Rezervacija {number} je ustvarjena',
        category:                'Kategorija',
        category_help:           'Kategorija ali šifra tipa sobe, npr. DBL. Prazno pomeni vse tipe.',
        category_placeholder:    'DBL',
        cell_tooltip:            'V valuti hiše: {price} · cenik: {plan}',
        children:                'Otrok',
        departure:               'Odhod',
        column_amount:           'Znesek',
        column_company:          'Družba',
        column_house:            'Hiša',
        column_last_stay:        'Zadnje bivanje',
        column_nights:           'Noči',
        column_open:             'Odprto',
        column_room_types:       'Tipi sob',
        column_spend:            'Poraba',
        column_stays:            'Bivanj',
        company:                 'Podjetje',
        company_help:            'Podjetje, ki plača sobo. Iskanje po imenu ali davčni številki.',
        company_placeholder:     'Poišči podjetje',
        cross_company:           'Hiši sta pri različnih družbah',
        cross_company_confirm:   'Razumem, da je to odpoved pri eni družbi in nova prodaja pri drugi',
        cross_company_hint:      'Prenos med družbama ni premik: v knjigah prve je odpoved, v knjigah druge nova prodaja. Razlog se zapiše v revizijsko sled obeh hiš.',
        errors_hint:             'Te hiše v odgovoru niso zajete.',
        errors_title:            'Hiš ni bilo mogoče prebrati',
        find:                    'Poišči',
        find_hint:               'Rezervacijo poiščemo po hiši in točni številki, ki jo ima gost na potrditvi.',
        find_title:              'Poišči rezervacijo',
        found_title:             'Najdena rezervacija',
        from_house:              'Iz hiše',
        grid_hint:               'Prosto velja za celotno bivanje ({nights} noči), ne za posamezen dan. Klik na tip sobe odpre novo rezervacijo.',
        grid_title:              'Razpoložljivost po hišah',
        guest:                   'Gost',
        guest_help:              'Gost, ki plača sobo. Iskanje po priimku.',
        guest_placeholder:       'Poišči gosta',
        guest_search_hint:       'Ena oseba čez vse hiše skupine: koliko je bivala, koliko je pustila in kje še dolguje.',
        guest_search_title:      'Poišči gosta',
        guest_unknown:           'V obsegu ni hiše, ki bi tega gosta poznala',
        houses_hint:             'Samo hiše, ki tega gosta poznajo. Obarvana vrstica: mesec nima tečaja, zato je poraba zunaj skupnega zneska.',
        houses_title:            'Po hišah',
        legend_free:             'Število ob tipu sobe je prostih sob za celotno bivanje.',
        legend_fx:               'Skupna poraba je preračunana po tečaju tekočega meseca.',
        legend_houses:           'Odprti zneski ostanejo v valuti, v kateri jih hiša terja.',
        legend_no_rate:          'Kjer mesec nima tečaja, je izpisana cena hiše v njeni valuti.',
        move:                    'Prenesi',
        move_failed:             'Prenosa ni bilo mogoče izvesti',
        move_half_done:          'Nova rezervacija je ustvarjena, izvorne pa NI bilo mogoče odpovedati. Gost ima sobo v obeh hišah — izvorno odpovejte ročno.',
        move_hint:               'Nova rezervacija nastane v ciljni hiši po njenem ceniku; izvorna se odpove. Predplačila in računi ostanejo pri izvorni hiši.',
        move_title:              'Prenesi v drugo hišo',
        moved:                   'Preneseno. Nova rezervacija: {number}',
        new_title:               'Nova rezervacija',
        no_company:              'Brez družbe',
        no_plan:                 'brez cenika',
        no_room_types:           'Ta hiša nima tipov sob',
        no_rows:                 'V obsegu ni hiš z odgovorom',
        not_found:               'Rezervacije s to številko v tej hiši ni',
        not_movable:             'Te rezervacije ni mogoče prenesti',
        not_movable_hint:        'Prenesemo lahko osnutek ali potrjeno rezervacijo. Prijavljenega gosta premakne recepcija, ki ima njegov ključ.',
        not_priced:              'brez cene',
        not_priced_hint:         'Hiša tega bivanja ne zna ovrednotiti — manjka cenik ali cena za katero od noči.',
        notes:                   'Opomba',
        number:                  'Številka rezervacije',
        number_placeholder:      'R-20261012-0007',
        open_in_reception:       'Odpri v recepciji',
        payer:                   'Plačnik',
        payer_company:           'Podjetje',
        payer_guest:             'Gost',
        per_period:              'Prosto velja za celotno bivanje, ne za posamezen dan.',
        pick_house:              'Izberite hišo',
        pick_room_type:          'Izberite tip sobe',
        reason:                  'Razlog',
        reason_help:             'Zapiše se v revizijsko sled obeh hiš.',
        reason_required:         'Obvezno pri prenosu med družbama.',
        room_type:               'Tip sobe',
        room_type_help:          'Ponujeni so samo tipi, ki so v ciljni hiši prosti za te datume.',
        search:                  'Poišči',
        search_hint:             'Eno bivanje, vse hiše v obsegu. Cena je za celotno bivanje.',
        search_title:            'Iskanje',
        source:                  'Vir',
        source_agency:           'Agencija',
        source_corporate:        'Podjetje',
        source_email:            'E-pošta',
        source_phone:            'Telefon',
        stay:                    'Bivanje',
        stays_hint:              'Vsa bivanja te osebe v skupini, najnovejše zgoraj.',
        stays_title:             'Bivanja',
        status:                  'Stanje',
        status_cancelled:        'Odpovedano',
        status_checked_in:       'Prijavljen',
        status_checked_out:      'Odjavljen',
        status_confirmed:        'Potrjeno',
        status_draft:            'Osnutek',
        status_no_show:          'Ni prišel',
        subtitle:                'centralna rezervacijska služba in gost 360',
        tab_availability:        'Razpoložljivost',
        tab_guest:               'Gost 360',
        tab_transfer:            'Prenos',
        tile_nights:             'Noči',
        tile_open:               'Odprto',
        tile_open_hint:          'po valutah, kot hiše terjajo',
        tile_spend:              'Poraba',
        tile_spend_excluded:     'brez {count} hiš brez tečaja',
        tile_stays:              'Bivanj',
        tile_stays_hint:         'hiš, ki gosta poznajo: {houses}',
        title:                   'Rezervacije',
        to_house:                'V hišo',
    },
    roi: {
        column_bookings:       'Rezervacije',
        column_clicks:         'Kliki',
        column_cost:           'Strošek',
        column_guest:          'Gost',
        column_guest_bookings: 'Rezervacij',
        column_guest_first:    'Prvič v',
        column_guest_houses:   'Hiše',
        column_guest_spend:    'Poraba čez hiše',
        column_guest_stays:    'Bivanj',
        column_new_guests:     'Novi',
        column_paid:           'Plačano',
        column_realised:       'Realizirano',
        column_roi:            'ROI',
        column_row:            'Kampanja',
        column_started:        'Začete',
        column_value:          'Vrednost',
        column_visits:         'Obiski',
        errors_hint:           'Te hiše niso odgovorile; njihovih številk v tabeli ni.',
        errors_title:          'Hiše brez odgovora',
        excluded_hint:         'Te hiše nimajo tečaja za mesec, v katerem je kampanja odšla — štetja ostanejo, denarja ni.',
        excluded_title:        'Hiše zunaj denarja',
        from:                  'Od',
        group_by:              'Združi po',
        group_campaign:        'Po kampanjah',
        group_channel:         'Po kanalih',
        group_house:           'Po hišah',
        guest_new:             'prvič pri nas',
        guests_hint:           'Poraba in bivanja so GOSTOVA čez vse hiše skupine in ne to, kar je zapravil ob tej kampanji.',
        guests_subtitle:       'gostje kampanje „{name}“',
        guests_title:          'Gostje',
        houses_count:          'hiš: {count}',
        legend_capped:         'Prikazanih je prvih 200 vrstic; zoži z iskanjem.',
        legend_guest_value:    'Poraba je gostova čez vse hiše v obsegu, iz profila „Gost 360“.',
        legend_guests_capped:  'Prikazanih je prvih {count} gostov.',
        legend_rate:           'Denar je preračunan po tečaju meseca, v katerem je kampanja odšla.',
        legend_window:         'Obdobje izbira rezervacije po dnevu nastanka; denar, ki jim sledi, je štet v celoti.',
        lost_short:            'odpovedi in neprihodi: {count}',
        nights_short:          'noči: {nights}',
        no_data:               'V tem obdobju ni kampanj.',
        no_guests:             'Te kampanje ni plačal noben gost.',
        no_rate_short:         'hiša brez tečaja',
        open_guests:           'Gostje',
        search:                'Išči kampanjo, kanal ali hišo',
        status_no_rate:        'ni tečaja za {month}',
        subtitle:              'kaj se je izplačalo čez hiše',
        table_by_campaign:     'Po kampanjah',
        table_by_channel:      'Po kanalih',
        table_by_house:        'Po hišah',
        table_hint:            'Vrstico razpri in pokaže hiše, ki so jo sestavile — vsaka v svoji valuti.',
        tile_bookings:         'Rezervacije',
        tile_bookings_hint:    'odpovedi in neprihodi: {cancelled}',
        tile_cost:             'Strošek',
        tile_cost_hint:        'hiš v obsegu: {count}',
        tile_cpa:              'Cena rezervacije',
        tile_cpa_hint:         'strošek na pridobljeno rezervacijo',
        tile_new_guests:       'Novi gostje',
        tile_new_guests_hint:  'plačniki brez bivanja pred obdobjem',
        tile_new_guests_unknown: 'preveč plačnikov za štetje',
        tile_return:           'Vrnjeno',
        tile_return_invoiced:  'po izdanih računih — denar še ni prejet',
        tile_return_paid:      'po prejetih plačilih',
        tile_roi:              'ROI',
        tile_roi_hint:         '0 % je na nuli',
        tile_roi_unknown:      'brez vpisanega stroška',
        title:                 'ROI',
        to:                    'Do',
        total_row:             'Skupaj ({campaigns} kampanj, {houses} hiš)',
    },
    campaign: {
        any_status:                'Vsa stanja',
        audience_count:            'Prejemnikov',
        audience_duplicate:        'Podvojenih naslovov',
        audience_hint:             'Razrešeno zdaj. Ob pošiljanju se razreši znova, zato gost, ki je danes zjutraj preklical soglasje, pisma ne dobi.',
        audience_house:            'Hiša',
        audience_no_consent:       'Brez soglasja ali naslova',
        audience_no_stay:          'Brez bivanja v obsegu',
        audience_sample:           'Primeri',
        audience_suppressed_group: 'Na skupinskem seznamu zavrnjenih',
        audience_suppressed_house: 'Na hišnem seznamu zavrnjenih',
        audience_title:            'Predogled občinstva',
        audience_total:            'Skupaj prejemnikov',
        budget:                    'Proračun',
        cancel:                    'Prekliči kampanjo',
        cancel_confirm:            'Prekličem kampanjo „{name}“? Poslanih pisem to ne razveljavi.',
        cancelled:                 'Kampanja „{name}“ je preklicana',
        channel_email:             'E-pošta',
        channel_gbp:               'Google Business',
        channel_seo:               'SEO',
        channel_social:            'Družbena omrežja',
        children_title:            'Po hišah',
        column_actions:            'Dejanja',
        column_at:                 'Kdaj',
        column_bookings:           'Rezervacij',
        column_channel:            'Kanal',
        column_child_status:       'Izid',
        column_cost:               'Strošek',
        column_currency:           'Valuta',
        column_email:              'Naslov',
        column_failed:             'Neuspešnih',
        column_funnel_status:      'Pretvorba',
        column_house:              'Hiša',
        column_houses:             'Hiš',
        column_language:           'Jezik',
        column_message:            'Opomba',
        column_name:               'Kampanja',
        column_note:               'Zaznamek',
        column_paid:               'Plačano',
        column_reason:             'Razlog',
        column_recipients:         'Prejemnikov',
        column_scheduled:          'Načrtovano',
        column_sent:               'Poslanih',
        column_source:             'Vir',
        column_source_house:       'Izvor',
        column_status:             'Stanje',
        column_template:           'Predloga',
        column_value:              'Vrednost',
        column_version:            'Različica',
        cost:                      'Strošek',
        cost_hint:                 'V poročevalski valuti skupine. Vpiše se ročno in se sme popraviti tudi po pošiljanju.',
        created:                   'Kampanja „{name}“ je ustvarjena',
        dedupe:                    'En gost, eno pismo',
        dedupe_hint:               'Dva profila z istim naslovom sta ena oseba. Piše hiša zadnjega bivanja.',
        dedupe_off:                'Izklopljeno',
        dedupe_on:                 'Vklopljeno',
        delete_confirm:            'Izbrišem osnutek kampanje „{name}“?',
        deleted:                   'Kampanja „{name}“ je izbrisana',
        dialog_edit:               'Uredi kampanjo',
        dialog_hint:               'Kampanja je ena odločitev in toliko pošiljk, kolikor je hiš v obsegu.',
        dialog_new:                'Nova kampanja',
        dpo_confirmed:             'Besedilo noge je potrdil pooblaščenec za varstvo podatkov',
        dpo_confirmed_hint:        'Dokler ni potrjeno, pošiljanje ni onemogočeno — je pa zapisano v revizijski sledi.',
        dpo_pending:               'Besedilo noge še ni potrjeno (DPO)',
        drawer_title:              'Kampanja',
        excluded_hint:             'Vsota je brez {count} hiš: {houses}',
        filter_status:             'Stanje',
        footer_en:                 'Noga (angleško)',
        footer_hint:               'Doda se na konec vsakega skupinskega pisma. Pove, da pošilja skupina, in katere hotele odjava zajame.',
        footer_placeholders:       'Uporabi {group} za ime skupine in {houses} za seznam hotelov.',
        footer_sl:                 'Noga (slovensko)',
        footer_title:              'Noga skupinskih pisem',
        funnel_from:               'Od',
        funnel_title:              'Lijak in donos',
        funnel_to:                 'Do',
        handle:                    'Ključ',
        houses:                    'Hiše',
        houses_all:                'Ves obseg ob pošiljanju',
        houses_hint:               'Prazno pomeni ves obseg računa, ki pritisne Pošlji.',
        language_fallback:         'Nadomestni jezik',
        language_fallback_hint:    'Jezik, v katerem piše hiša, za katero znamka nima besedila v njenem jeziku.',
        name:                      'Ime',
        new:                       'Nova kampanja',
        no_campaigns:              'Ni kampanj',
        no_suppressions:           'Seznam je prazen',
        no_templates:              'Ni predlog',
        owner:                     'Nosilec',
        preview:                   'Osveži predogled',
        preview_hint:              'Predogled ne piše ničesar in ne pošlje ničesar.',
        reason_bounce:             'Odboj',
        reason_complaint:          'Pritožba',
        reason_manual:             'Ročno',
        reason_unsubscribed:       'Odjava',
        roi_unknown:               'Brez stroška ni donosa',
        saved:                     'Kampanja „{name}“ je shranjena',
        scheduled_at:              'Načrtovano',
        scheduled_hint:            'Prazno pomeni, da pošlje človek s pritiskom.',
        segment_all_consented:     'Vsi s soglasjem, ki so kdaj bivali',
        segment_kind:              'Občinstvo',
        segment_last_stay_window:  'Zadnje bivanje v oknu',
        send:                      'Pošlji',
        send_confirm:              'Pošljem kampanjo „{name}“ {count} prejemnikom iz {houses} hiš? Pisem ni mogoče preklicati.',
        send_test:                 'Pošlji testno',
        send_test_hint:            'Eno pismo na en naslov, iz hiše pošiljateljice skupine. Ne zapiše ničesar.',
        send_test_title:           'Testno pismo',
        sent:                      'Kampanja „{name}“ je poslana',
        settings_saved:            'Nastavitve so shranjene',
        status_cancelled:          'Preklicano',
        status_draft:              'Osnutek',
        status_scheduled:          'Načrtovano',
        status_sending:            'V pošiljanju',
        status_sent:               'Poslano',
        subtitle:                  'skupinske kampanje in predloge znamke',
        suppression_add:           'Dodaj naslov',
        suppression_added:         'Naslov je na skupinskem seznamu',
        suppression_dialog_hint:   'Naslov, ki ga nobena hiša skupine ne bo več pisala.',
        suppression_dialog_title:  'Nov naslov na seznamu',
        suppression_email:         'Naslov',
        suppression_locked:        'Odjave ne umakne nihče razen gosta',
        suppression_note:          'Zaznamek',
        suppression_reason:        'Razlog',
        suppression_remove_confirm: 'Umaknem naslov s skupinskega seznama zavrnjenih?',
        suppression_removed:       'Naslov je umaknjen s seznama',
        suppression_search:        'Iskanje po naslovu',
        tab_campaigns:             'Kampanje',
        tab_footer:                'Noga in nastavitve',
        tab_suppressions:          'Izključitve',
        tab_templates:             'Predloge',
        template:                  'Predloga',
        template_active:           'Na voljo',
        template_active_no:        'Umaknjeno',
        template_active_yes:       'Na voljo',
        template_body:             'Besedilo',
        template_channel:          'Kanal',
        template_created:          'Predloga „{name}“ je ustvarjena',
        template_delete_confirm:   'Izbrišem predlogo „{name}“?',
        template_deleted:          'Predloga „{name}“ je izbrisana',
        template_dialog_edit:      'Uredi predlogo',
        template_dialog_hint:      'Predloga pripada enoti in jo podedujejo vse enote pod njo.',
        template_dialog_new:       'Nova predloga',
        template_hint:             'Podedovane predloge so označene.',
        template_inherited:        'Podedovano',
        template_inherited_from:   'Podedovano iz: {unit}',
        template_language:         'Jezik',
        template_name:             'Ime',
        template_new:              'Nova predloga',
        template_saved:            'Predloga „{name}“ je shranjena',
        template_title:            'Naslov',
        test_address:              'Naslov za test',
        test_sent:                 'Testno pismo je poslano',
        tile_bookings:             'Rezervacij',
        tile_cost:                 'Strošek',
        tile_return:               'Donos',
        tile_roi:                  'ROI',
        title:                     'Kampanje',
        total_recipients:          'Prejemnikov skupaj',
        totals:                    'Skupina',
        unit:                      'Enota',
        unit_all:                  'Vse enote',
        window_from:               'Bivali od',
        window_to:                 'Bivali do',
    },
}
